<template>
    <div class="apaympro-container">

        <!-- Top Bar Component --> 
        <top-bar></top-bar> 
        <!-- Top Bar Component -->

        <!-- Loader -->
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="bars"
            :opacity="1"
        ></loading>

        <!-- Form Payment -->
        <div class="apaympro-wrapper animated fadeIn" v-if="formPayment">
            <div id="payment-page-pay" class="apaympro-page">
                <div class="apaympro-header">

                    <div 
                        class="company-logo" 
                        v-if="dataPage.business_logo"
                        style="width: 150px !important; justify-content: center;"
                    >
                        <img
                            :src="dataPage.business_logo"
                            alt="Business Logo"
                        />
                    </div>

                    <div class="page-info">
                        <h3 id="page-name" class="page-name">
                            {{ dataPage.type == 'ONG' || dataPage.type == 'PERSONNALITE' ? 
                            $t('text_header.donation.value') : $t('text_header.pay.value') }} 
                            <strong style="text-transform: uppercase;"> 
                                {{ dataPage.business_name }} 
                                <img src="../assets/img/badge-check.png" v-if="dataPage.verified == '1'" width="15" style="margin-top: -3px;" /> 
                            </strong>
                            <p class="company-name mb-2" style="font-weight: 500; font-size: 11px">{{ dataPage.ville }} / {{ dataPage.type }}</p>
                        </h3>
                        <p class="company-name text-dark" v-if="dataPage.type == 'SP'">
                            {{$t('text_header.by.value')}} <span style="font-weight: 600;">{{ dataPage.nom }}</span> <br>
                            <span class="font-12" style="text-transform: none;">{{$t('text_header.enterprising.value')}}</span>
                        </p>
                        <p class="company-name" v-if="dataPage.type !== 'SP' && dataPage.type !== 'AUTRE'">
                            <span style="font-weight: 600;">
                                <!-- {{ dataPage.type }}  -->
                                {{ dataPage.rcc !== "0" || dataPage.rcc.includes("---") == "-1" ? 
                                dataPage.rcc : '' }}</span>
                        </p>
                    </div>

                    <div class="page-description" v-if="dataPage.description_page">
                        <span id="tooltip-description-page" style="cursor: pointer;">
                            {{ 
                                dataPage.description_page
                            }}
                        </span>
                        <b-tooltip target="tooltip-description-page" triggers="hover">
                            {{ dataPage.description_page_2 }}
                        </b-tooltip>
                    </div>

                    <!-- Social medias -->
                    <div class="company-name mt-3" style="text-transform: none;">
                        <span v-if="dataPage.facebook">
                            <a class="btn btn-lg btn-link btn-facebook" :href="dataPage.facebook" target="_blank" style="padding: 0;">
                                <i class="fab fa-facebook-f"></i>
                            </a> 
                        </span> 
                        <span v-if="dataPage.instagram" class="mr-4 ml-4">
                            <a class="btn btn-lg btn-link btn-instagram" :href="dataPage.instagram" target="_blank" style="padding: 0;">
                                <i class="fab fa-instagram"></i>
                            </a> 
                        </span> 
                        <span v-if="dataPage.whatsapp">
                            <a class="btn btn-lg btn-link btn-whatsapp" :href="dataPage.whatsapp" target="_blank" style="padding: 0;">
                                <i class="fab fa-whatsapp"></i>
                            </a> 
                        </span> 
                    </div>
                    <!-- Social medias -->  

                </div>
                <div class="body">
                    
                    <!-- Bloc success payment -->
                    <div id="payment-success"
                        :class="hideRecu == true ? 'payment-success animated fadeIn text-center hidden' : 'payment-success animated fadeIn text-center'"
                    >
        
                        <img src="../assets/confirmico.gif" alt="Logo payment success" />
                        <div>
                            <strong>
                                {{ $t('payment_successfully.success.value') }}
                            </strong>
                            <br>
                            <span> 
                                {{ $t('payment_successfully.by.value') }} {{ dataFormulaire.nom }} {{ dataFormulaire.prenom }}
                            </span>
                            <h2 class="payment-success-message" style="font-weight: 900; font-size: 3rem;">
                                <strong>{{ dataFormulaire.montant }} {{ dataFormulaire.devise == "XOF" ? "F" : dataFormulaire.devise }}</strong>
                            </h2>
                            <div v-if="dataFormulaire.motif" class="mb-3">
                                {{ $t('payment_successfully.reason.value') }} : {{ dataFormulaire.motif }}
                            </div>

                            <span class="" 
                                style="
                                    align-items: center;
                                    justify-content: center;
                                "
                            >
                                {{ $t('payment_successfully.by.value') }}  
                                <img :src="require(`../assets/img/menu/${logoSmallDevice}`)" width="70" alt="Logo" style="position: relative; left: 5px;" />
                            </span>
                        </div>
                    </div>

                    <div class="element-wrap element-wrap-for-submit mt-5 mb-5">  
                        <a
                            :href="'https://pay.apaym.com/recu/'+ refPayment" target="_blank"
                            :class="hideRecu == true ? 'btn btn-dark hidden btn-block' : 'btn btn-dark btn-block font-15'"
                        >{{ $t('payment_successfully.receipt.value') }}</a>

                        <a
                            href="https://apaym.com/app" target="_blank"
                            :class="hideRecu == true ? 'btn btn-dark hidden btn-block' : 'btn btn-outline-dark btn-block font-15'"
                        >{{ $t('download_apaym.value') }}</a>

                        <button @click="reload" :class="hideRecu == true ? 'btn btn-link hidden btn-block' : 'btn btn-link btn-block'" style="font-weight: 800; color: #0e2abd;">
                            {{ $t('payment_successfully.button.value') }}
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <!-- Form Payment -->

        <!-- Error Section -->
        <div class="apaympro-wrapper animated fadeIn" v-if="showErrorPage">
            <div class="apaympro-page">
                <div class="apaympro-header">
                    <div class="page-info mt-3 mb-3">
                        <h3
                            style="
                                font-size: 20px;
                                font-weight: normal;
                                margin: 20px auto 0px;
                                width: 80%;
                                line-height: 1.3;
                            "
                        >
                            {{ $t('transaction_paid.text.value') }}
                        </h3>
                    </div>
                    <div class="mt-3">
                        <img
                            src="../assets/refusico.gif"
                            alt="icon page not found - payment page apaym pro"
                            width="200"
                            height="200"
                            style="width: 200px; height: 100%"
                        />

                    </div>
                    <div class="element-wrap element-wrap-for-submit mt-5 mb-5">
                        <a
                            type="button"
                            id="pay-btn"
                            href="https://pay.apaym.com"
                            target="_blank"
                            class="btn btn-outline-danger btn-block"
                        >{{ $t('transaction_paid.apaym.value') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Error Section -->

        
        <!-- ****************************************************** -->
        <!-- ****************************************************** -->
        <!-- Section du paiement | Affichage des moyens de paiement -->
        <!-- ****************************************************** -->
        <!-- ****************************************************** -->
        <div class="apaympro-wrapper animated fadeIn container mb-5" v-if="showPaymentSection" style="width: 500px;">
            <div class="apaympro-page">
                <div class="apaympro-header">
                    <!-- Sharing bloc -->
                    <!-- <div class="mt-4 sharingBloc">
                        <div class="sharingBloc">
                            <span 
                                style="
                                    font-size: 13px; 
                                    font-weight: 800;
                                    padding-left: 50px;
                                    padding-right: 50px;
                                "
                            >
                                {{ 
                                    $t('payment_modal.sharing.value') 
                                }}
                            </span>
                            <div>
                                <ShareNetwork
                                    network="facebook"
                                    :url="'https://pay.apaym.com/ref/'+ refPayment"
                                    :title="dataPage.business_name +' - Paye moi comme tu veux'"
                                    description="Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym"
                                    quote="Le moyen de paiement marchand le plus simplifié et pratique"
                                    hashtags="APaymPro,PaieMoi,Marchand"
                                    class="btn btn-lg btn-link btn-facebook"
                                    style="padding-left: 13px !important; padding-right: 13px !important;"
                                >
                                    <i class="fab fa-facebook-f"></i>
                                </ShareNetwork>
                                <ShareNetwork
                                    network="WhatsApp"
                                    :url="'https://pay.apaym.com/ref/'+ refPayment"
                                    :title="dataPage.business_name +' - Paye moi comme tu veux'"
                                    description="Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym"
                                    quote="Le moyen de paiement marchand le plus simplifié et pratique"
                                    hashtags="APaymPro,PaieMoi,Marchand"
                                    class="btn btn-lg btn-link btn-whatsapp"
                                    style="padding-left: 13px !important; padding-right: 13px !important;"
                                >
                                    <i class="fab fa-whatsapp"></i>
                                </ShareNetwork>
                                <ShareNetwork
                                    network="telegram"
                                    :url="'https://pay.apaym.com/ref/'+ refPayment"
                                    :title="dataPage.business_name +' - Paye moi comme tu veux'"
                                    description="Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym"
                                    quote="Le moyen de paiement marchand le plus simplifié et pratique"
                                    hashtags="APaymPro,PaieMoi,Marchand"
                                    class="btn btn-lg btn-link btn-telegram"
                                    style="padding-left: 13px !important; padding-right: 13px !important;"
                                >
                                    <i class="fab fa-telegram"></i>
                                </ShareNetwork>
                                <button type="button" class="btn btn-lg btn-link btn-telegram" style="padding-left: 13px !important; padding-right: 13px !important;" @click="copy">
                                    <input 
                                        id="paymentLink"
                                        :value="'https://pay.apaym.com/ref/'+ refPayment"
                                        type="hidden"
                                    />
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </div>
                    </div> -->
                    <!-- Sharing bloc -->

                    <div class="mb-1 mt-4" style="display: flex; flex-direction: column; width: 100%;">
                        <div class="text-modal">
                            <!-- <img v-if="!dataPage.business_logo" src="../assets/Logo-APAYM-PRO.png" width="140" alt="Logo APaym Pro"/> -->
                            <div class="company-logo mb-3" style="width: 150px;" v-if="dataPage.business_logo">
                                <img
                                    :src="dataPage.business_logo"
                                    alt="Business Logo"
                                    width="140"
                                />
                            </div>
                        </div>

                        <!-- Montant -->
                        <div v-if="showMenu" style="display: contents;">
                            <div 
                                style="text-align: center; display: flex; flex-direction: column;">
                                <span style="font-size: 25px; font-weight: 600; letter-spacing: 1.2px">
                                    {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: dataFormulaire.devise }).format(montantSave) }}
                                </span>
                            </div>
                        </div>
                        <!-- Montant -->

                        <div class="text-modal" style="padding-top: 5px;">
                            {{ 
                                dataPage.type == 'ONG' || dataPage.type == 'PERSONNALITE' ? $t('text_header.donation.value') : $t('text_header.pay.value')  
                            }} 
                            <strong class="mr-1" style="text-transform: uppercase"> 
                                {{ dataPage.business_name }} <img src="../assets/img/badge-check.png" v-b-tooltip.hover :title="$t('text_certified_account.value')" v-if="dataPage.verified == '1'" width="15" style="margin-top: -3px;" />
                            </strong> 
                            {{ $t('text_header.by.value')  }}
                        </div>
                    </div>
                </div>

                <div class="body">
                    <form 
                        class="payment-form" 
                        :style="
                            (dataPage.frais == '1' || 
                            dataPage.frais == '2' || 
                            dataPage.pourboire == '1') && menuSelected !== 'Visa QR' ? 
                            'padding: 25px; padding-bottom: 0;' : 
                            '' 
                        "
                    >
                        <div>
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Menu -->
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <div class="container" 
                                style="padding: 30px; padding-top: 0px !important; padding-bottom: 0px !important;"
                            >
                                <div class="row mt-3" v-if="showMenu">
                                    <div class="row">
                                        <div class="col-4 mb-4" 
                                            v-for="mode in modesPaiementDispo"
                                            :key="mode.mode"
                                            v-show="mode.actif == 'oui'"
                                        > 
                                            <a 
                                                @click="selectMenu(mode.libelle)"
                                                href="javascript:;"
                                                v-if=" mode.actif == 'oui' "
                                            >
                                                <img :src="require(`../assets/img/menu/${mode.img}`)" alt="Logo Operateur">
                                            </a>
                                       </div>
                                    </div>
                                </div>
                            </div>
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Menu -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Change Menu -->
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <div
                                style="
                                    display: flex;
                                    flex-direction: row;
                                    z-index: 1;
                                    align-items: center;
                                    width: 100%;
                                    padding: 13px;
                                    justify-content: center;
                                    background: #f4f4f4;
                                    border-radius: 10px;
                                "
                                v-if="showContent"
                                >   

                                <div
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        z-index: 1;
                                        align-items: center;
                                        width: 100%;
                                        justify-content: space-between;
                                    "
                                >
                                    <span class="font-17" style="font-weight: 800;">
                                        {{ 
                                            menuSelected == "VISA" || menuSelected == "MASTERCARD" ? typeCarte : menuSelected
                                        }}
                                    </span>
                                    <a 
                                        href="javascript:;" style="color: #0e2abd; font-weight: 600;"
                                        @click=" showHeader = showContent = false ; showMenu = true; "
                                    >
                                        <i class="fas fa-exchange-alt" style="transform: rotate(-60deg);"></i> {{ $t('payment_modal.change_menu.value') }}
                                    </a>
                                </div>

                            </div>
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Change Menu -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Header -->
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <div
                                style="display: flex; flex-direction: row;
                                    z-index: 1;
                                    align-items: center;
                                    width: 100%;
                                    padding-top: 10px;
                                    padding-bottom: 10px;
                                    justify-content: space-between;
                                    border-bottom: 2px solid rgb(244, 244, 244) ;
                                    margin-bottom: 12px;
                                "
                                v-if="showHeader"
                            >
                                <img 
                                    :src="require(`../assets/img/menu/${logoSmallDevice}`)" 
                                    width="75" alt="Logo moyen de paiement" 
                                />
                                <div
                                    style="display:flex;
                                        flex-direction: column;
                                        top: 5px; z-index: 1;
                                        align-items: flex-end;
                                        padding: 5px;
                                    "
                                >
                                    <div  
                                        style="text-align: end; 
                                            display: flex; 
                                            flex-direction: column;
                                        "
                                    >
                                        <span>
                                            <button 
                                                class="btn btn-link btn-facebook" type="button" 
                                                style="line-height: 1; margin-top: -2px; padding: 0;"
                                                v-b-modal.openUpdateClientInfo
                                            > 
                                                {{ $t('update_data.update.value') }}
                                            </button> 
                                            {{ dataFormulaire.society }}
                                        </span>
                                        <span> {{ dataFormulaire.nom }} </span>
                                        <span>
                                            {{ indice.code }} {{ dataFormulaire.telephone }} 
                                            <span v-if=" nombre_transactions !== '' ">
                                                <img :src="require(`../assets/img/badges/${imgStatus}`)" width="20" style="position: relative; top: -3px;"> {{ statusClient }}
                                            </span>
                                        </span>
                                        <span style="font-size: 25px; font-weight: 600; letter-spacing: 1.2px">
                                            {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: dataFormulaire.devise }).format(dataFormulaire.montant) }}
                                        </span>
                                        <span v-if="dataFormulaire.motif">{{ dataFormulaire.motif.trim() }}</span>
                                    </div>

                                </div>

                            </div>
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Header -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- ********** Content ********* -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                            <div v-if="showContent">
                                
                                <!-- Visa QR -->
                                <div v-if="menuSelected == 'Visa QR'">

                                    <loading
                                        :active.sync="isLoadingQr"
                                        :can-cancel="true"
                                        :on-cancel="onCancelQr"
                                        :is-full-page="fullPageQr"
                                        loader="bars"
                                        :opacity="1"
                                    ></loading>

                                    <div class="checkout__stage">
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>
                                                    <div class="visa-qr-container__header">
                                                        <p
                                                            class="instruction mt-3"
                                                            style=""
                                                        >{{ $t('payment_modal.visa_qr.text.value') }}</p>
                                                    </div>
                                                    <a 
                                                        download="visa-qr-code.png" class="btn btn-light mt-2 mb-2"
                                                        :href="qrCodeUri" 
                                                        style="height: 35px; line-height: 1.4; background: #f4f4f4; border: #f4f4f4;"
                                                    >
                                                        {{ $t('payment_modal.download_visa_qr.value') }}
                                                    </a>

                                                    <!-- Fees -->
                                                    <div class="container d-flex justify-content-between mt-2 mb-3" v-if="dataPage.frais == '1' || dataPage.frais == '2' ">
                                                        <div>
                                                            <h6 v-if="dataPage.frais == '1'">
                                                                {{ $t('text_fees_payment.value') }}
                                                            </h6>
                                                            <h6 v-if="dataPage.frais == '2'">
                                                                {{ $t('text_fees_forced_payment.value') }}
                                                            </h6>
                                                        </div>
                                                        <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                            <input type="checkbox" :checked="checkedFeesApaym" @click="feeAmountQr">
                                                            <span style="left: 20px;"></span>
                                                        </label>
                                                        <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                            <input type="checkbox" :checked="checkedFeesApaym" @click="feeAmountQr">
                                                            <span style="left: 20px;"></span>
                                                        </div>
                                                    </div>
                                                    <div class="container d-flex justify-content-between" v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesApaym">
                                                        <div>
                                                            <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                        </div>
                                                        <div>
                                                            <span class="font-12"> 
                                                                {{  
                                                                    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_apaym) / 100 )  : 0 )
                                                                }} 
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- Fees -->

                                                    <!-- Montant total -->
                                                    <div class="container d-flex justify-content-between mb-3" 
                                                        v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                    >
                                                        <div>
                                                            <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                        </div>
                                                        <div>
                                                            <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                {{ 
                                                                    
                                                                    new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                        parseInt(dataFormulaire.montant) 
                                                                    )
                                                                }} 
                                                                
                                                            </span>
                                                            <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- Montant total -->

                                                    <div class="qr__wrapper">
                                                        <div class="qr__code">
                                                            <img
                                                                v-if="qrCodeUri"
                                                                name="qrCodeImage"
                                                                alt="APaym Pro QR Code"
                                                                :src="qrCodeUri"
                                                                id="qrCodeImage"
                                                                style="width: 70%;"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="qr__wrapper mt-2 mb-4">
                                                        <div class="qr__code">
                                                            <i
                                                                class="fas fa-spinner fa-spin"
                                                                style="font-size: 20px;"
                                                                v-if="qrCodeUri"
                                                            ></i>
                                                        </div>
                                                        <div class="mt-2">
                                                            {{ $t("text_visa_qr_waiting.value") }}
                                                        </div>
                                                    </div>

                                                    <!-- Download APaym -->
                                                    <div class="qr__wrapper mb-5">
                                                        <div class="row">

                                                            <div class="col-md-12 mb-2">
                                                                <strong>
                                                                    {{ $t('download_apaym.value') }}
                                                                </strong>
                                                            </div>

                                                            <div class="col-md-1"></div>
                                                            <div class="col-md-5">
                                                                <a 
                                                                    href="https://apps.apple.com/app/id1211381693"
                                                                    target="_blank"
                                                                >
                                                                    <img 
                                                                        src="../assets/img/Logo-App-Store.png" 
                                                                        alt="AppStore icon"
                                                                        width="180"
                                                                    >
                                                                </a>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <a 
                                                                    href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan"
                                                                    target="_blank"
                                                                >
                                                                    <img 
                                                                        src="../assets/img/logo-plstore.png" 
                                                                        alt="PlayStore icon"
                                                                        width="180"
                                                                    >
                                                                </a>
                                                            </div>
                                                            <div class="col-md-1"></div>
                                                        </div>
                                                    </div>
                                                    <!-- Download APaym -->
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- Visa QR -->

                                <!-- Visa / Mastercard -->
                                <div v-if="menuSelected == 'VISA' || menuSelected == 'MASTERCARD' ">
                                    <div class="checkout__stage">
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingBicici"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelBicici"
                                                            :is-full-page="fullPageBicici"
                                                            loader="bars"
                                                            :opacity="1"
                                                        ></loading>
                                                    </div>

                                                    <div class="visa-qr-container__header">

                                                        <p class="instruction mt-3" v-if="!isBicici">
                                                            {{ $t('payment_modal.visa.text.value') }}
                                                        </p>
                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="biciciNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">
                                                                    {{ $t('payment_modal.bicici_payment_failure_title.value') }}
                                                                </p>
                                                                <div
                                                                    class="error-information"
                                                                >
                                                                    {{ $t('payment_modal.bicici_payment_failure_details.value') }}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    
                                                    <div class="qr__wrapper container">
                                                        
                                                        <div
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -40px 0px;' : '' "
                                                        >

                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mt-2 mb-3"
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' " 
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesCb" @click="tauxMontantCb">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesCb" @click="tauxMontantCb">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between"
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' " 
                                                                v-if=" ( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesCb"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_cb) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->

                                                            <div
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' "
                                                            >
                                                                <button
                                                                    type="button"
                                                                    :class=" !cardType ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    @click="sendCardPayment"
                                                                    :disabled="!cardType"
                                                                >
                                                                    {{ $t('payment_modal.visa.button.value') }} {{ typeCarte }}
                                                                </button>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- Visa / Mastercard -->

                                <!-- Orange Money -->
                                <div v-if="menuSelected == 'Orange Money'">
                                    
                                    <div class="checkout__stage">
                                        <loading
                                            :active.sync="isLoadingOrange"
                                            :can-cancel="false"
                                            :on-cancel="onCancelOrange"
                                            :is-full-page="fullPageOrange"
                                            loader="bars"
                                            :opacity="1"
                                        ></loading>
                                        <section>
                                            <div class="visa-qr-container" style="">
                                                <div>
                                                    <div class="visa-qr-container__header">

                                                        <p class="instruction mt-3" v-if="!mobileDevice">
                                                            {{ $t('payment_modal.om.text.value') }}
                                                        </p>
                                                        <p class="instruction mt-3" v-if="mobileDevice">
                                                            {{ $t('payment_modal.om.text2.value') }}
                                                        </p>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="orangeNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">
                                                                    {{ $t('payment_modal.om.payment_failure_title.value') }}
                                                                </p>
                                                                <div
                                                                    class="error-information"
                                                                >
                                                                    {{ $t('payment_modal.om.payment_failure_details.value') }}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    
                                                    <div class="qr__wrapper container">
                                                        <div 
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -40px 0px;' : '' "
                                                        >

                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesOm" @click="tauxMontantOm">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesOm" @click="tauxMontantOm">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesOm"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_om) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->

                                                            <div 
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                                v-if="dataPage.isDeleg == '3'"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendOM('ussd')"
                                                                    class="btn btn-dark btn-block mt-3"
                                                                >
                                                                    {{ $t('payment_modal.om.button.value') }}
                                                                </button>
                                                            </div>

                                                            <div 
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                                v-if="dataPage.isDeleg !== '3'"
                                                            >

                                                                <button v-if="mobileDevice"
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendOM('app')"
                                                                    class="btn btn-dark btn-block mb-3"
                                                                >
                                                                    {{ $t('payment_modal.om.button2.value') }}
                                                                </button>

                                                                <span class="text-dark mt-5 mb-5" style="font-weight: 900" v-if="mobileDevice">
                                                                    {{ $t('payment_modal.om.or_om.value') }}
                                                                </span>

                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendOM('ussd')"
                                                                    :class="mobileDevice ? 'btn btn-outline-dark btn-block mt-3' : 'btn btn-dark btn-block mt-3'"
                                                                    style
                                                                >
                                                                    {{ $t('payment_modal.om.button.value') }}
                                                                </button>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- Orange Money -->

                                <!-- Wave -->
                                <div v-if="menuSelected == 'Wave'">
                                    <div class="checkout__stage">
                                        <loading
                                            :active.sync="isLoadingWave"
                                            :can-cancel="false"
                                            :on-cancel="onCancelWave"
                                            :is-full-page="fullPageWave"
                                            loader="bars"
                                            :opacity="1"
                                        ></loading>
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>

                                                    <div class="visa-qr-container__header">

                                                        <p class="instruction mt-3" v-if="!mobileDevice">
                                                            {{ $t('payment_modal.wave.text.value') }}
                                                        </p>

                                                        <p class="instruction mt-3" v-if="mobileDevice">
                                                            {{ $t('payment_modal.wave.text_2.value') }}
                                                        </p>

                                                        <!-- Display waiting message -->
                                                        <div
                                                            v-if="waveOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div class="qr__code">
                                                                <i
                                                                    class="fas fa-spinner fa-spin"
                                                                    style="font-size: 20px;"
                                                                ></i>
                                                            </div>
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >
                                                                    {{ $t('payment_modal.wave.waiting.value') }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <!-- Display waiting message -->

                                                        <!-- Display error message -->
                                                        <div class="displayerror__details mt-3" v-if="waveNOkay">
                                                            <div>
                                                                <p class="paiement-failed">
                                                                    {{ $t('payment_modal.wave.payment_failure_title.value') }}
                                                                </p>
                                                                <div
                                                                    class="error-information"
                                                                >
                                                                    {{ $t('payment_modal.wave.payment_failure_details.value') }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Display error message -->

                                                    </div>
                                                    
                                                    <div class="qr__wrapper container">

                                                        <div 
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -40px 0px;' : '' "
                                                        >
                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mt-2 mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesWave" @click="tauxMontantWave">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesWave" @click="tauxMontantWave">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesWave"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_wave) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->

                                                            <!-- Wave button -->
                                                            <div
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                            >

                                                                <!-- Payer avec Wave / QR Code -->
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    v-if="!mobileDevice"
                                                                    @click="sendWave()"
                                                                    class="btn btn-dark btn-block mt-3"
                                                                >
                                                                    {{ $t('payment_modal.wave.button.value') }}
                                                                </button>
                                                                <!-- Payer avec Wave / QR Code -->

                                                                <!-- Payer avec l'application Wave -->
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    v-if="mobileDevice"
                                                                    @click="sendWave()"
                                                                    class="btn btn-dark btn-block mt-3"
                                                                >
                                                                    {{ $t('payment_modal.wave.button_2.value') }}
                                                                </button>
                                                                <!-- Payer avec l'application Wave -->

                                                            </div>
                                                            <!-- Wave button -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- Wave -->

                                <!-- MTN Money -->
                                <div v-if="menuSelected == 'MTN Money'">
                                    <div class="checkout__stage">
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>
                                                    <div class="mt-5">
                                                        <loading
                                                            :active.sync="isLoadingMomo"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelMomo"
                                                            :is-full-page="fullPageMomo"
                                                            loader="bars"
                                                            :opacity="1"
                                                        ></loading>
                                                    </div>

                                                    <div class="visa-qr-container__header">

                                                        <p class="instruction mt-3">
                                                            {{ $t('payment_modal.mtn.text.value') }} 
                                                            <strong class="custom-text">*133#</strong>
                                                            {{ $t('payment_modal.mtn.text2.value') }}
                                                        </p>

                                                        <!-- MTN Message en cas d'échec -->
                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="mtnNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">{{ $t('payment_modal.mtn.payment_failure_title.value') }}</p>
                                                                <div
                                                                    class="error-information"
                                                                >{{ $t('payment_modal.mtn.payment_failure_details.value') }}</div>
                                                            </div>
                                                        </div>
                                                        <!-- MTN Message en cas d'échec -->

                                                        <!-- MTN Message en cas d'attente de confirmation du paiement -->
                                                        <div
                                                            v-if="mtnOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >

                                                            <div class="qr__code">
                                                                <i
                                                                    class="fas fa-spinner fa-spin"
                                                                    style="font-size: 20px;"
                                                                ></i>
                                                            </div>

                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >{{ $t('payment_modal.mtn.payment_pending.value') }}</p>
                                                            </div>

                                                        </div>
                                                        <!-- MTN Message en cas d'attente de confirmation du paiement -->

                                                    </div>
                                                    
                                                    <div class="qr__wrapper container">

                                                        <div class="element-pair-container mt-2 mb-3">
                                                            <div class="element-wrap element-wrap-on-left">
                                                                <multiselect
                                                                    v-model="indiceMobileMoney"
                                                                    :options="options"
                                                                    :multiple="false"
                                                                    placeholder="Indicatif"
                                                                    tag-placeholder="Indicatif"
                                                                    track-by="code"
                                                                    label="country"
                                                                    :searchable="true"
                                                                    disabled
                                                                >
                                                                    <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                                                    <span slot="noResult"></span>
                                                                </multiselect>
                                                            </div>
                                                            <div class="element-wrap element-wrap-on-right"> 
                                                                <input
                                                                    type="text"
                                                                    :placeholder="$t('payment_modal.mtn.placeholder.value')"
                                                                    class="element-is-input"
                                                                    v-model="dataMoMo.numero"
                                                                    v-mask="'## ## ## ## ##'"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div 
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -40px 0px;' : '' "
                                                        >
                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesMtn" @click="tauxMontantMtn">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesMtn" @click="tauxMontantMtn">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesMtn"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_mtn) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->

                                                            <div
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendMoMo"
                                                                    :class="!dataMoMo.numero ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    :disabled="!dataMoMo.numero"
                                                                >{{ $t('payment_modal.mtn.button.value') }}</button>
                                                            </div>

                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- MTN Money -->

                                <!-- Moov Money -->
                                <div v-if="menuSelected == 'Moov Money'">
                                    <div class="checkout__stage">
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>

                                                    <div class="mt-5">
                                                        <loading
                                                            :active.sync="isLoadingFlooz"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelFlooz"
                                                            :is-full-page="fullPageFlooz"
                                                            loader="bars"
                                                            :opacity="1"
                                                        ></loading>
                                                    </div>

                                                    <div class="visa-qr-container__header">

                                                        <p
                                                            class="instruction mt-3"
                                                        >
                                                            {{ $t('payment_modal.moov.text.value') }}
                                                        </p>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="moovNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">{{ $t('payment_modal.moov.payment_failure_title.value') }}</p>
                                                                <div
                                                                    class="error-information"
                                                                >{{ $t('payment_modal.moov.payment_failure_details.value') }}</div>
                                                            </div>
                                                        </div>

                                                        <div
                                                            v-if="moovOkay"
                                                            class="displayerror__details mt-3 mb-2"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            
                                                            <div class="qr__code mt-2 pt-2" v-if="showVerifMoov">
                                                                <i
                                                                    class="fas fa-spinner fa-spin"
                                                                    style="font-size: 20px;"
                                                                ></i>
                                                            </div>   
                                                            <div class="mt-2 pt-2" v-if="!showVerifMoov && !showInProcessMoov">
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;"
                                                                >
                                                                    {{ $t('payment_modal.moov.payment_waiting_1.value') }}
                                                                </p>
                                                            </div>
                                                            <span class="timer" v-if="!showVerifMoov && !showInProcessMoov">
                                                                {{ formattedTimeLeft }} min
                                                            </span>
                                                            <div class="mt-2" v-if="!showVerifMoov && !showInProcessMoov">
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;"
                                                                >
                                                                    {{ $t('payment_modal.moov.payment_waiting_2.value') }}
                                                                </p>
                                                            </div>
                                                            <div class="mt-2" v-if="showVerifMoov">
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >
                                                                    {{ $t('payment_modal.moov.payment_pending.value') }}
                                                                </p> 
                                                            </div>

                                                            <div class="qr__code mt-2 pt-2" v-if="showInProcessMoov">
                                                                <i
                                                                    class="fas fa-spinner fa-spin"
                                                                    style="font-size: 20px;"
                                                                ></i>
                                                            </div> 

                                                            <div class="mt-2" v-if="showInProcessMoov">
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >
                                                                    {{ $t('payment_modal.moov.payment_waiting_3.value') }}
                                                                </p> 
                                                            </div>

                                                        </div>
                                                        
                                                    </div>
                                                    
                                                    <div class="qr__wrapper container">

                                                        <div class="element-pair mt-2 mb-3">
                                                            <div class="element-pair-container">
                                                                <div class="element-wrap element-wrap-on-left">
                                                                    <multiselect
                                                                        v-model="indiceMobileMoney"
                                                                        :options="options"
                                                                        :multiple="false"
                                                                        placeholder="Indicatif"
                                                                        tag-placeholder="Indicatif"
                                                                        track-by="code"
                                                                        label="country"
                                                                        :searchable="true"
                                                                        disabled
                                                                    >
                                                                        <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                                                        <span slot="noResult"></span>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="element-wrap element-wrap-on-right"> 
                                                                    <input
                                                                        type="text"
                                                                        :placeholder="$t('payment_modal.moov.placeholder.value')"
                                                                        class="element-is-input"
                                                                        v-model="dataMoov.numero"
                                                                        v-mask="'## ## ## ## ##'"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div 
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -40px 0px;' : '' "
                                                        >

                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesMoov" @click="tauxMontantMoov">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesMoov" @click="tauxMontantMoov">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesMoov"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_moov) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->

                                                            <div
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendMoov"
                                                                    :class="!dataMoov.numero ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    :disabled="!dataMoov.numero"
                                                                >   
                                                                    {{ $t('payment_modal.moov.button.value') }}
                                                                </button>
                                                            </div>
                                                            
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- Moov Money -->

                                <!-- APaym USSD -->
                                <div v-if="menuSelected == 'APaym USSD'">
                                    <div class="checkout__stage">
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>
                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingAPaym"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelAPaym"
                                                            :is-full-page="fullPageAPaym"
                                                            loader="bars"
                                                            :opacity="1"
                                                        ></loading>
                                                    </div>
                                                    <div class="visa-qr-container__header">

                                                        <!-- <strong class="mb-2" style="font-size: 22px;">
                                                            *766#
                                                        </strong> -->
                                                        <p class="instruction mt-3">
                                                            {{ $t('payment_modal.ussd_apaym.text.value') }}
                                                            <strong class="custom-text">*766#</strong>
                                                            {{ $t('payment_modal.ussd_apaym.text2.value') }}
                                                        </p>

                                                    </div>
                                                    
                                                    <div class="qr__wrapper">

                                                        <div class="element-pair mt-2 mb-3">
                                                            <div class="element-pair-container mt-4">
                                                                <div class="element-wrap element-wrap-on-left">
                                                                    <multiselect
                                                                        v-model="dataApaymPay.indice"
                                                                        :options="options"
                                                                        :multiple="false"
                                                                        placeholder="Indicatif"
                                                                        tag-placeholder="Indicatif"
                                                                        track-by="code"
                                                                        label="country"
                                                                        :searchable="true"
                                                                    >
                                                                        <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                                                        <span slot="noResult"></span>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="element-wrap element-wrap-on-right">
                                                                    <input
                                                                        class="element-is-input"
                                                                        type="text"
                                                                        v-mask="'## ## ## ## ##'"
                                                                        v-model="dataApaymPay.numApaym"
                                                                        :placeholder="$t('payment_modal.ussd_apaym.placeholder.value')"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="element-wrap">
                                                            <input
                                                                type="text"
                                                                class="element-is-input"
                                                                :disabled="!dataApaymPay.numApaym"
                                                                v-model="dataApaymPay.codeApaym"
                                                                :placeholder="$t('payment_modal.ussd_apaym.placeholder2.value')"
                                                            />
                                                        </div>

                                                        <div 
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -25px 0px;' : '' "
                                                        >

                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesApaym" @click="tauxMontantApaym">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesApaym" @click="tauxMontantApaym">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between"
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesApaym"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_apaym) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->

                                                            <div
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendAPaym"
                                                                    :class="!dataApaymPay.numApaym || !dataApaymPay.codeApaym ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    :disabled="!dataApaymPay.numApaym || !dataApaymPay.codeApaym"
                                                                >
                                                                    {{ $t('payment_modal.ussd_apaym.button.value') }}
                                                                </button>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                <!-- APaym USSD -->

                                <!-- APaym -->
                                <div v-if="menuSelected == 'APaym'">
                                    <!-- Content APaym Payment - Listing des cartes visa du profil APaym -->
                                    <div class="checkout__stage">
                                        <section>
                                            <div class="visa-qr-container">
                                                <div>

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingAPaymAuth"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelAPaymAuth"
                                                            :is-full-page="fullPageAPaymAuth"
                                                            loader="bars"
                                                            :opacity="1"
                                                        ></loading>
                                                    </div>

                                                    <div class="visa-qr-container__header">

                                                        <div v-if="showCard == true">
                                                            {{ $t('payment_modal.apaym.choose_card.value') }}
                                                        </div>
                                                        <div 
                                                            class="btn btn-link" 
                                                            style=" display: flex; align-items: center;
                                                                background: none;
                                                                text-align: center;
                                                                justify-content: center;
                                                                font-weight: 900;
                                                                height: 30px;
                                                            "
                                                            v-if="showCard == true"
                                                            @click="disconnectApaym"
                                                        >
                                                            {{ $t('payment_modal.apaym.logout.value') }}
                                                        </div>
                                                        <p class="instruction mt-3" v-if="loginApaym">
                                                            {{ $t('payment_modal.apaym.text.value') }}
                                                        </p>

                                                    </div>
                                                    
                                                    <div class="qr__wrapper">

                                                        <div class="element-pair mt-2 mb-3" v-if="loginApaym">
                                                            <div class="element-pair-container mt-4">
                                                                <div class="element-wrap element-wrap-on-left">
                                                                    <multiselect
                                                                        v-model="dataApaymPayAuth.indice"
                                                                        :options="options"
                                                                        :multiple="false"
                                                                        placeholder="Indicatif"
                                                                        tag-placeholder="Indicatif"
                                                                        track-by="code"
                                                                        label="country"
                                                                        :searchable="true"
                                                                    >
                                                                        <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                                                        <span slot="noResult"></span>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="element-wrap element-wrap-on-right">
                                                                    <div
                                                                        style="
                                                                            display: flex;
                                                                            flex-direction: row;
                                                                            align-items: center;
                                                                        "
                                                                    >
                                                                        <input
                                                                            class="element-is-input"
                                                                            type="text"
                                                                            v-mask="'## ## ## ## ##'"
                                                                            v-model="dataApaymPayAuth.numApaym"
                                                                            :placeholder="$t('payment_modal.apaym.placeholder.value')"
                                                                        />
                                                                        <i
                                                                            class="fas fa-arrow-right searchIcon"
                                                                            aria-hidden="true"
                                                                            @click="sendAPaymAuth"
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <div class="container mt-4 d-flex-inline">
                                                                <p 
                                                                    class="text-danger mb-2" 
                                                                    v-if="this.error !== null"
                                                                >
                                                                    <i class="fas fa-exclamation-circle"></i>
                                                                    {{ this.error }}
                                                                </p>
                                                                <vue-hcaptcha
                                                                    class="h-captcha"
                                                                    @verify="onVerify"
                                                                    @expired="onExpired"
                                                                    @error="onError"
                                                                    sitekey="cc4778d8-c49d-40ad-950c-ab566138bda2"
                                                                ></vue-hcaptcha>
                                                            </div> -->
                                                        </div>

                                                        <div class="element-wrap" v-if="hideCodePay">
                                                            <!-- <label class="instruction">{{ $t('payment_modal.apaym.code_sms.value') }}</label> -->
                                                            <input
                                                                type="text"
                                                                class="element-is-input"
                                                                :disabled="!dataApaymPayAuth.numApaym"
                                                                v-model="dataApaymPayAuth.codeApaym"
                                                                :placeholder="$t('payment_modal.apaym.placeholder2.value')"
                                                            />
                                                        </div>

                                                        <div
                                                            class="element-wrap element-wrap-for-submit"
                                                            :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'background: #f5f5f5; margin: 40px -25px 0px;' : '' "
                                                            v-if="hideCodePay"
                                                        >

                                                            <img 
                                                                src="../assets/img/trait-recap.png" 
                                                                alt="Illustration zigzag recap" 
                                                                style="position:relative; top: -10px;"
                                                                v-if=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >

                                                            <!-- Fees -->
                                                            <div 
                                                                class="container d-flex justify-content-between mb-3"
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' " 
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' "
                                                            >
                                                                <div>
                                                                    <h6 v-if="dataPage.frais == '1'">
                                                                        {{ $t('text_fees_payment.value') }}
                                                                    </h6>
                                                                    <h6 v-if="dataPage.frais == '2'">
                                                                        {{ $t('text_fees_forced_payment.value') }}
                                                                    </h6>
                                                                </div>
                                                                <label class="ui-switch switch-solid" v-if="dataPage.frais == '1'">
                                                                    <input type="checkbox" :checked="checkedFeesApaym" @click="tauxMontantApaym">
                                                                    <span style="left: 20px;"></span>
                                                                </label>
                                                                <div class="ui-switch switch-solid" v-if="dataPage.frais == '2'">
                                                                    <input type="checkbox" :checked="checkedFeesApaym" @click="tauxMontantApaym">
                                                                    <span style="left: 20px;"></span>
                                                                </div>
                                                            </div>
                                                            <div 
                                                                class="container d-flex justify-content-between"
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' " 
                                                                v-if="( dataPage.frais == '1' || dataPage.frais == '2' ) && checkedFeesApaym"
                                                            >
                                                                <div>
                                                                    <span class="font-12">{{ $t('text_fees.value') }}</span>
                                                                </div>
                                                                <div>
                                                                    <span class="font-12"> 
                                                                        {{  
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montantSave ? parseInt(montantSave) * ( parseInt(dataPage.taux_apaym) / 100 )  : 0 )
                                                                        }} 
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Fees -->

                                                            <!-- Montant total -->
                                                            <div class="container d-flex justify-content-between mb-3" 
                                                                :style=" dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 0px 30px 0px 30px; top: -20px; position: relative;' : '' "
                                                                v-if="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' "
                                                            >
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;">TOTAL</span>
                                                                </div>
                                                                <div>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="dataFormulaire.montant"> 
                                                                        {{ 
                                                                            
                                                                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                                                                parseInt(dataFormulaire.montant) 
                                                                            )
                                                                        }} 
                                                                        
                                                                    </span>
                                                                    <span class="" style="font-weight: 800; font-size: 22px;" v-if="!dataFormulaire.montant"> 
                                                                        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(0) }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- Montant total -->
                                                            
                                                            <div
                                                                :style="dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ? 'padding: 5px 25px 15px 25px; top: -20px; position: relative;' : '' " 
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="pay-btn"
                                                                    @click="sendAPaymToken"
                                                                    :class="!dataApaymPayAuth.numApaym || !dataApaymPayAuth.codeApaym ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    :disabled="!dataApaymPayAuth.numApaym || !dataApaymPayAuth.codeApaym"
                                                                >
                                                                    {{ $t('payment_modal.apaym.button.value') }}
                                                                </button>
                                                            </div>

                                                        </div>

                                                        <!-- Liste des cartes -->
                                                        <div v-if="showCard == true">
                                                            <ul
                                                                class="list-unstyled text-left"
                                                                :style="cardsLength > 5 ? 'height: 392px; overflow-y: scroll;' : 'height: auto;'"
                                                            >
                                                                <li
                                                                    class="media py-3"
                                                                    v-for="(carte,i) in cards"
                                                                    :key="i"
                                                                    style="cursor: pointer;"
                                                                    @click="payWithApaym(carte)"
                                                                >
                                                                    <div class="mr-3 position-relative">
                                                                        <img
                                                                            class
                                                                            :src="require(`../assets/img/cards/${carte.imgCard}`)"
                                                                            alt="image"
                                                                            width="45"
                                                                        />
                                                                    </div>
                                                                    <div class="media-body">
                                                                        <div
                                                                            class="d-flex justify-content-between"
                                                                            style="text-align: left;"
                                                                        >
                                                                            <div>
                                                                                {{ carte.nickname }}
                                                                                <br />
                                                                                <span class="font-11">
                                                                                    Visa **** {{ carte.last_4_digit }}
                                                                                    <img
                                                                                        src="../assets/img/icons/icon-recieve_money-193.png"
                                                                                        alt
                                                                                        width="15"
                                                                                        class="ml-2"
                                                                                        v-b-tooltip
                                                                                        title="Carte favorite"
                                                                                        :hidden="carte.favori_card == false"
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <!-- <div>Cliquez sur l'une de vos cartes pour effectuer le paiement</div> -->
                                                        </div>
                                                        <!-- Liste des cartes -->

                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    <!-- Content APaym Payment - Listing des cartes visa du profil APaym -->
                                </div>
                                <!-- APaym -->
                                
                            </div>

                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- ********** Content ********* -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Second bloc -->
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <div
                                :style=" ( dataPage.frais == '1' || dataPage.frais == '2' || dataPage.pourboire == '1' ) && menuSelected == 'Visa QR' ? 
                                    'display: flex; flex-direction: column; z-index: 1; width: 100%; padding: 13px; justify-content: center; background: rgb(244, 244, 244); border-radius: 10px;' : 
                                    'display: flex; flex-direction: column; z-index: 1; width: 100%; padding: 13px; justify-content: center; '
                                "
                                v-if="loyalty_card == '1' && showHeader "
                            >
                                <label class="mt-2" style="font-size: 12px; font-weight: 600;">
                                    {{ $t("payment_modal.loyalty_card.value") }}
                                </label>
                                <div
                                    style="display:flex; flex-direction: row; top: 5px; z-index: 1; align-items: center; justify-content: center; padding: 5px;"
                                >
                                    <span
                                        :style="pointLoyal.paid !== 1 ? 'border-radius: 50% !important; height: 25px; width: 25px; border: 2px solid #261b64;' : 'border-radius: 50% !important; height: 25px; width: 25px; background: #261b64;'"
                                        class="mr-2"
                                        v-for="pointLoyal in pointLoyalty"
                                        :key="pointLoyal.id"
                                    >
                                    </span>
                                    <img src="../assets/img/gift.png" alt="Gift" width="40">
                                </div>
                                <label class="mt-2" style="font-size: 12px; font-weight: 600;" v-if="cadeau_a_offrir">
                                    {{ $t("payment_modal.bonus_offered.value") }} {{ cadeau_a_offrir.slice(0, 30) }}
                                </label>
                            </div>
                            <!-- **************************** -->
                            <!-- **************************** -->
                            <!-- Second bloc -->
                            <!-- **************************** -->
                            <!-- **************************** -->

                        </div>
                    </form>
                </div>
            </div>

            <!-- Let someone pay for you -->
            <div 
                class="element-wrap element-wrap-for-submit flex flex-justify--space-between pfm-payForm__divider"
            >
                <div class="divider-dashed"></div>
                <p>
                    {{ 
                        $t('payment_modal.sharing_or.value') 
                    }}
                </p>
                <div class="divider-dashed"></div>
            </div>

            <div class="element-wrap element-wrap-for-submit" style="margin-bottom: 4.3rem;"> 
                <a 
                    href="javascript:;" 
                    @click="letSomeonePay" 
                    class="btn btn-block font-15 btn-pay-by-someone"
                >
                    {{ $t('payment_modal.sharing.value') }}
                </a>
            </div>
            <!-- Let someone pay for you -->

        </div>
        <!-- ****************************************************** -->
        <!-- ****************************************************** -->
        <!-- Section du paiement | Affichage des moyens de paiement -->
        <!-- ****************************************************** -->
        <!-- ****************************************************** -->

        <div class="apaympro-wrapper animated fadeIn container mb-5" v-if="sharingSection" style="width: 500px;">
            
            <div class="apaympro-page">
                <!-- Header -->
                <div class="apaympro-header">

                    <div class="mb-1" style="display: flex; flex-direction: column; width: 100%;">
                        <div class="text-modal mt-5 mb-4">
                            <img src="../assets/Logo-APAYM-PRO.png" alt="Logo APaym Pro" width="150">
                        </div>

                        <!-- Montant -->
                        <div class="mt-3" style="display: contents;">
                            <div 
                                v-if="typeForm == 'normal'" 
                                style="text-align: center; display: flex; flex-direction: column;">
                                <span style="font-size: 25px; font-weight: 600; letter-spacing: 1.2px">
                                    {{ 
                                        new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                            parseInt(montantSave)                                         
                                        )
                                    }}
                                </span>
                            </div>
                            <div 
                                v-if="typeForm == 'quickly'" 
                                style="text-align: center; display: flex; flex-direction: column;">
                                <span style="font-size: 25px; font-weight: 600; letter-spacing: 1.2px">
                                    {{ 
                                        new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(
                                            parseInt(montantSave)                                         
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                        <!-- Montant -->
                    
                        <div class="text-modal" style="padding-top: 5px;">
                            <strong class="mb-4 font-16">
                                {{ 
                                    $t('payment_modal.sharing_text.value') 
                                }}
                            </strong>

                            <p class="font-14">
                                {{ 
                                    $t('payment_modal.sharing_sous_text.value') 
                                }}
                            </p>
                        </div>
                    </div>
                    <!-- Sharing bloc -->
                    <div class="sharingBloc">
                        <div class="sharingBloc">
                            <div>
                                <ShareNetwork network="facebook" :url="'https://pay.apaym.com/ref/'+ refPayment"
                                    :title="dataPage.business_name +' - Paye moi comme tu veux'"
                                    description="Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym"
                                    quote="Le moyen de paiement marchand le plus simplifié et pratique"
                                    hashtags="APaymPro,PaieMoi,Marchand" class="btn btn-lg btn-link btn-facebook"
                                >
                                    <i class="fab fa-facebook-f" style="font-size: 1.6rem;"></i>
                                </ShareNetwork>

                                <ShareNetwork
                                    network="WhatsApp" :url="'https://pay.apaym.com/ref/'+ refPayment"
                                    :title="dataPage.business_name +' - Paye moi comme tu veux'"
                                    description="Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym"
                                    quote="Le moyen de paiement marchand le plus simplifié et pratique"
                                    hashtags="APaymPro,PaieMoi,Marchand" class="btn btn-lg btn-link btn-whatsapp"
                                >
                                    <i class="fab fa-whatsapp" style="font-size: 1.6rem;"></i>
                                </ShareNetwork>

                                <ShareNetwork network="telegram" :url="'https://pay.apaym.com/ref/'+ refPayment"
                                    :title="dataPage.business_name +' - Paye moi comme tu veux'"
                                    description="Veuillez me payer via Visa QR, Cartes Bancaires, Mobile Money, USSD APaym et APaym"
                                    quote="Le moyen de paiement marchand le plus simplifié et pratique"
                                    hashtags="APaymPro,PaieMoi,Marchand" class="btn btn-lg btn-link btn-telegram"
                                >
                                    <i class="fab fa-telegram" style="font-size: 1.6rem;"></i>
                                </ShareNetwork>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 pfm__copy" style="border-color: rgb(53 59 65);">
                        <p class="pfm__copy-link-preview" style="color: rgb(53 59 65);">
                            https://pay.apaym.com/ref/{{ refPayment }}
                        </p>
                        <button 
                            class="pfm__copy-button button button--cta" @click="copy"
                            style="background: rgb(53 59 65); line-height: 20px; display: flex; color: #ffffff; height: -webkit-fill-available;"
                        >
                            <span> {{ $t('payment_modal.copy.value') }} </span>
                        </button>
                    </div>

                    <!-- Sharing bloc -->
                </div>
                <!-- Header -->
            </div>

            <!-- Let someone pay for you -->
            <div 
                class="element-wrap element-wrap-for-submit flex flex-justify--space-between pfm-payForm__divider"
                style="margin: 30px 0px -10px; padding: 15px 7px 0px 7px;"
            >
                <div class="divider-dashed"></div>
                <p>
                    {{ 
                        $t('payment_modal.sharing_or.value') 
                    }}
                </p>
                <div class="divider-dashed"></div>
            </div>

            <div class="element-wrap element-wrap-for-submit" style="margin-bottom: 4.3rem;"> 
                <a
                    href="javascript:;"
                    @click="letSomeonePay"
                    class="btn btn-dark btn-block font-15"
                >
                    {{ 
                        $t('payment_modal.sharing_2.value') 
                    }}
                </a>
            </div>
            <!-- Let someone pay for you -->

        </div>


        <!-- Footer APaym Secured Badge -->
        <footer-item></footer-item>
        <!-- Footer APaym Secured Badge -->

        <!-- *********** -->
        <!-- *********** -->
        <!-- MODAL BLOC -->
        <!-- *********** -->
        <!-- *********** -->


        <!-- Orange money modal -->
        <b-modal
            class="modal-content"
            id="openOrangeMoney"
            ref="openOrangeMoneyModal"
            no-close-on-backdrop
            hide-footer
            hide-header
            scrollable
            style="padding: 0;"
            size="lg"
        >
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openOrangeMoneyModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openOrangeMoneyModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div class="modalOrangeMoney">
                <iframe
                    :src="urlOrange"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>
        </b-modal>
        <!-- Orange money modal -->

        <!-- Wave modal -->
        <b-modal
            class="modal-content"
            id="openWave"
            ref="openWaveModal"
            no-close-on-backdrop
            hide-footer
            hide-header
            scrollable
            style="padding: 0;"
            size="lg"
        >
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openWaveModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openWaveModal')"
            >
                <i class="fas fa-times" style="font-size: 23px; color: #ffffff"></i>
            </div>
            <div class="modalOrangeMoney">
                <iframe
                    :src="urlWave"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>
        </b-modal>
        <!-- Wave modal -->

        <!-- BICICI modal -->
        <b-modal
            class="modal-content"
            id="openBicici"
            ref="openBiciciModal"
            no-close-on-backdrop
            hide-footer
            hide-header
            scrollable
            style="padding: 0;"
        >
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openBiciciModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openBiciciModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div class="modalBiciciMoney">
                <iframe
                    :src="contentBicici"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>
        </b-modal>
        <!-- BICICI money modal -->

        <!-- Update client information modal -->
        <b-modal
            class="modal-content"
            id="openUpdateClientInfo"
            ref="openUpdateClientInfoModal"
            hide-footer
            hide-header
            scrollable
            style="padding: 0; border-radius: 0 !important;"
            title="Modifications des informations"
        >

            <div class="modal-header">
                <h4 class="modal-title">
                    {{ $t('update_data.update_title.value') }}
                </h4>
                <button 
                    class="btn btn-link btn-floating btn-sm btn-close-modal"
                    @click="closeModal('openUpdateClientInfoModal')"
                    style="left: 93%; top: 20px;"
                >
                    <i class="fas fa-times font-18"></i>
                </button>
            </div>
            
            <form class="payment-form mt-5">
                <div class="container mt-3 mb-3">
                    <div class="element-pair">
                        <div class="element-label">
                            <span>
                                {{ $t('update_data.form.number.value') }}
                            </span>
                        </div>
                        <div class="element-pair-container">
                            <div
                                class="element-wrap element-wrap-on-left"
                            >
                                <multiselect
                                    v-model="indice"
                                    :options="options"
                                    :multiple="false"
                                    placeholder="Indicatif"
                                    tag-placeholder="Indicatif"
                                    track-by="code"
                                    label="country"
                                    :searchable="true"
                                >
                                    <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                    <span slot="noResult"></span>
                                </multiselect>
                            </div>
                            <div class="element-wrap element-wrap-on-right"> 
                                <input
                                    class="element-is-input"
                                    type="text"
                                    v-mask="'## ## ## ## ##'"
                                    v-model="dataFormulaire.telephone"
                                    name="telephone"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="element-pair">
                        <div class="element-pair-container">
                            <div class="element-wrap">
                                <div class="element-label">
                                    <span>{{ $t('update_data.form.society.value') }}</span>
                                </div>
                                <input
                                    v-model="dataFormulaire.society"
                                    type="text"
                                    class="element-is-input"
                                    name="societe"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="element-pair">
                        <div class="element-pair-container">
                            <div class="element-wrap">
                                <div class="element-label">
                                    <span>{{ $t('update_data.form.fullname.value') }}</span> {{ $t('update_data.form.s.value') }}
                                </div>
                                <input
                                    v-model="dataFormulaire.nom"
                                    type="text"
                                    class="element-is-input"
                                    name="name"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="element-wrap">
                        <div class="element-label">
                            <span>{{ $t('update_data.form.email.value') }}</span>
                        </div>
                        <input
                            v-model="dataFormulaire.email"
                            type="email"
                            class="element-is-input"
                            name="email"
                        />
                    </div>

                    <div class="element-wrap">
                        <div class="element-label">
                            <span>{{ $t('update_data.form.reason.value') }}</span>
                        </div>
                        <input
                            v-model="dataFormulaire.motif"
                            type="text"
                            class="element-is-input"
                            name="motif"
                            maxlength="40"
                        >
                    </div>

                    <div class="element-wrap element-wrap-for-submit mt-3 mb-3">
                        <button
                            type="button"
                            @click="updateClientInfos"
                            class="btn btn-dark btn-block"
                        >{{ $t('update_data.form.button.value') }}</button>
                    </div>
                    <!-- <div class="modal-footer" style="border-top: none;"> -->
                        <!-- <button class="btn btn-light" type="button" @click="closeModal('openUpdateClientInfoModal')">Fermer</button> -->
                        <!-- <button class="btn btn-dark btn-block" @click="updateClientInfos" type="button">Mettre à jour</button></div> -->
                </div>
            </form>

        </b-modal>
        <!-- Update client information modal -->

        <!-- *********** -->
        <!-- *********** -->
        <!-- MODAL BLOC -->
        <!-- *********** -->
        <!-- *********** -->

    </div>
</template>


<script src="https://js.pusher.com/7.0/pusher.min.js"></script>
<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import json from '../constants/flags.json';
    import { sweetAlert } from "../constants/functions";
    import axios from 'axios';
    import { apiUrl, _reference } from '../constants/config';
    import { trim } from 'jquery';
    import Multiselect from "vue-multiselect";
    import TopBar from '../components/TopBar' ;
    import FooterItem from '../components/FooterItem';
    import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

    const TIME_LIMIT = 180; 

    export default {
        props: {
            reCaptchaCompat: {
                type: Boolean,
                default: true
            },
            sentry: {
                type: Boolean,
                default: true
            },
        },
        components: {
            Loading,
            VueHcaptcha,
            multiselect: Multiselect,
            'top-bar': TopBar,
            'footer-item': FooterItem,
        },
        data() {
            return {
                showCard: false, cards: [], cardsLength: 0, loginApaym: true,
                hideCodePay: false, tabIndex: 0, mtnOkay: false, mtnNOkay: false,
                orangeOkay: false, orangeNOkay: false, moovOkay: false, moovNOkay: false,
                waveOkay: false, waveNOkay: false, isLoadingWave: false, fullPageWave: false,
                biciciNOkay: false, hideRecu: true, isLoading: false, fullPage: true,
                isLoadingQr: false, fullPageQr: false, isLoadingMomo: false, fullPageMomo: false,
                isLoadingAPaym: false, fullPageAPaym: false, isLoadingAPaymAuth: false, fullPageAPaymAuth: false,
                isLoadingOrange: false, fullPageOrange: false, isLoadingFlooz: false, fullPageFlooz: false,
                isLoadingBicici: false, fullPageBicici: false, indice: "225", indiceMobileMoney: "225",
                json: [], qrCodeUri: "", stopInterval: null, urlOrange: "", isBicici: false, isOtherCard: false,
                cardChoice: true, contentBicici: "", formBicici: false, cardType: "", sharingSection: false,
                dataFormulaire: {
                    nom: "",
                    prenom: "",
                    telephone: "",
                    email: "",
                    montant: "",
                    motif: "",
                    devise: "XOF",
                    society: ""
                }, 
                dataFormulaireQuick: {
                    nom: "",
                    prenom: "",
                    telephone: "",
                    email: "",
                    montant: "",
                    motif: "",
                    devise: "XOF"
                },
                dataApaymPay: {
                    indice: "225",
                    numApaym: "",
                    codeApaym: ""
                },
                dataApaymPayAuth: {
                    indice: "225",
                    numApaym: "",
                    codeApaym: "",
                    token: ""
                },
                dataVisaCard: {
                    pan : "",
                    expiration: "",
                    cvv: ""
                },
                dataMoMo: {
                    numero : ""
                },
                dataMoov: {
                    numero : ""
                },
                url_data: {
                    code_page: "",
                    slug: ""
                },
                dataPage: {
                    name_page: "",
                    description_page: "",
                    description_page_2: "",
                    business_logo: "",
                    business_name: "",
                    business_vpan: "",
                    amount: "",
                    page_redirect: "",
                    email_notify: "",
                    success_message: "",
                    seo_image: "",
                    slug: "",
                    frais: "",
                    type: "",
                    nom: "",
                    verified: "",
                    rcc: "",
                    business_email: "",
                    business_phone: "",
                    facebook: "",
                    instagram: "",
                    whatsapp: "",
                    ville: "",
                    deleg_pdci: "",
                    taux_apaym: "",
                    taux_om: "",
                    taux_mtn: "",
                    taux_cb: "",
                    taux_moov: "",
                    taux_wave: ""
                },
                options: [], pageType: "default",
                company: {
                    name: "",
                    address: "",
                },
                invoice: {
                    id: "",
                    items: [],
                    dueDate: ""
                },
                customer: {
                    name: "",
                    email: "",
                    description: "",
                },
                logo: "", logoOfSelectedService: "visa-qr-1.png", logoSmallDevice: "visa-qr-1.png",
                showErrorPage: false, formPayment: true, formQuiclyPayment: true, infosSup: true,
                merchantList: [], searchMerchant: "", typeForm: "", modePay: "", refPayment: "",
                langs: ['fr', 'en'], modalOrange: false, modalBicici: false, mobileDevice: false,
                checkedFeesApaym: false, checkedFeesOm: false, checkedFeesWave: false,
                checkedFeesMtn: false, checkedFeesCb: false, checkedFeesMoov: false, montantSave: "",
                modePayment: "", showMenu: true, showHeader: false, showContent: false, menuSelected: "Visa QR",
                dataYangoRechargement: { 
                    driver_profil_id : "",
                    driver_phone_number: "",
                    amount: "",
                    profil_id: "",
                    ref_transaction: "",
                    adresse_ip: "",
                    device_ID: "",
                    phone_Name: ""
                },
                pointLoyalty: [], loyalty_card: "", nombre_points: 0, cadeau_a_offrir: "",
                nombre_paiements: 0, nombre_transactions: 0, statusClient: "", imgStatus: "bronze.png",
                is_platinum_card: "", showPaymentSection: false, formPayment: false, modalWave: false,
                urlWave: "", stopInterval: null,  timePassed: 0, timerInterval: null, showVerifMoov: false, 
                showInProcessMoov: false, typeCarte: "", verified: false, expired: false, token: null, 
                eKey: null, error: null,
                modesPaiementDispo : [
                    {
                        "mode" : "qr",
                        "actif" : "non",
                        "libelle" : "Visa QR",
                        "img": "visa-qr.png"
                    },
                    {
                        "mode" : "cb_visa",
                        "actif" : "non",
                        "libelle" : "VISA",
                        "img": "visa.png" 
                    },
                    {
                        "mode" : "cb_mastercard",
                        "actif" : "non",
                        "libelle" : "MASTERCARD",
                        "img": "mastercard.png" 
                    },
                    {
                        "mode" : "orange_money",
                        "actif" : "non",
                        "libelle" : "Orange Money",
                        "img": "om.png"
                    },
                    {
                        "mode" : "wave",
                        "actif" : "non",
                        "libelle" : "Wave",
                        "img": "wave.png" 
                    },
                    {
                        "mode" : "mtn_money",
                        "actif" : "non",
                        "libelle" : "MTN Money",
                        "img": "momo.png" 
                    },
                    {
                        "mode" : "moov_money",
                        "actif" : "non",
                        "libelle" : "Moov Money",
                        "img": "flooz.png" 
                    },
                    {
                        "mode" : "ussd",
                        "actif" : "non",
                        "libelle" : "APaym USSD",
                        "img": "apaym-ussd.png" 
                    },
                    {
                        "mode" : "apaym",
                        "actif" : "non",
                        "libelle" : "APaym",
                        "img": "apaym.png" 
                    }
                ]
            }
        },
        computed: {
            formattedTimeLeft() {
                const timeLeft = this.timeLeft;
                const minutes = Math.floor(timeLeft / 60);
                let seconds = timeLeft % 60;

                if (seconds < 10) {
                    seconds = `0${seconds}`;
                }

                return `${minutes}:${seconds}`;
            },

            timeLeft() {
                return TIME_LIMIT - this.timePassed;
            },
        },
        methods: {

            // Allows numbers only, amount field
            numbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            updateClientInfos(){

                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug) );
                dataSend.append("nom", this.dataFormulaire.nom.replace(/\s/g, "") !== "" ? trim(this.dataFormulaire.nom) : "Client" ); 
                // dataSend.append("prenom", this.dataFormulaire.prenom.replace(/\s/g, "") !== "" ? trim(this.dataFormulaire.prenom) : "" );
                dataSend.append("numero", this.dataFormulaire.telephone !== "" ? this.indice.code +""+ this.dataFormulaire.telephone.replace(/\s/g, "") : "Numero inconnu");
                dataSend.append("indice", this.indice.code !== "" ? this.indice.code : "Indice inconnu");
                dataSend.append("email", this.dataFormulaire.email !== "" ? trim(this.dataFormulaire.email) : "" );
                dataSend.append("motif", this.dataFormulaire.motif !== "" ? trim(this.dataFormulaire.motif) : "" );
                dataSend.append("societe", this.dataFormulaire.society !== "" ? trim(this.dataFormulaire.society) : "" );

                axios.post(apiUrl + 'api/payment-merchant/update',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if ( response.data.code == 1 ) {

                        this.refPayment = response.data["reference"] ;
                        this.$refs['openUpdateClientInfoModal'].hide();

                        // Set the phone number to APaym login
                        if ( response.data.numero_consumer !== "Numero inconnu" ) {

                            this.getIndiceJson() ;
                            this.dataFormulaire.telephone = response.data.numero_consumer.replace(response.data.indice, "") ;
                            this.dataApaymPay.numApaym = response.data.numero_consumer.replace(response.data.indice, "") ;
                            this.dataApaymPayAuth.numApaym = response.data.numero_consumer.replace(response.data.indice, "") ;

                            if ( response.data.indice !== "Indice inconnu" ) {
                                this.indice = response.data.indice ;
                                this.dataApaymPayAuth.indice = response.data.indice ;
                                this.dataApaymPay.indice = response.data.indice ;
                                this.getIndiceJson() ;
                            } else {
                                this.indice = "" ;
                            }

                            if ( 
                                response.data.indice == "225" && 
                                response.data.numero_consumer.replace(/\s/g, "").substring(3).length == 10 
                            ) {

                                // Set MTN MoMo number if it begins by 05 or Set Moov Money number if it begins by 01
                                var indice = response.data.numero_consumer.replace(/\s/g, "").substring(3) ;
                                var first2Chiffres = indice.replace(/\s/g, "").substring(0,2) ;

                                if ( first2Chiffres == "05" ) {
                                    this.dataMoMo.numero = response.data.numero_consumer.replace(/\s/g, "").substring(3) ;
                                } else if ( first2Chiffres == "01" ) {
                                    this.dataMoov.numero = response.data.numero_consumer.replace(/\s/g, "").substring(3) ;
                                }
                            }

                        } else {

                            this.indice = "" ;
                            this.dataFormulaire.telephone = response.data.numero_consumer ;
                        }

                        this.dataPage.business_name = response.data.business ;
                        this.dataFormulaire.montant = response.data.amount ;
                        this.dataFormulaire.devise = response.data.currency ;
                        this.dataFormulaire.nom = response.data.consumer_name ;
                        this.dataFormulaire.society = response.data.society_name ;
                        this.dataPage.type = response.data.type ;
                        this.dataFormulaire.motif = trim(response.data.motif) ;
                        this.dataPage.description_page = response.data.description_page ;
                        this.dataPage.business_logo = response.data.business_logo !== "" ? "https://apaym.com/cms/images/logo_marchand/"+ response.data.business_logo : "" ;
                        this.dataPage.verified = response.data.verified;  
                        
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                    
                });

            },

            copy() {
                
                try {
                    var successful = navigator.clipboard.writeText('https://pay.apaym.com/ref/'+ this.refPayment); 
                    sweetAlert(this.$swal, true, 'top-end', 'success', this.$t('payment_modal.apaym.sweet_alert_text.value'), '');
                    
                } catch (err) {
                    console.log(err)
                }
            },

            copyDesktop() {
                
                // this.$refs.clone.focus();
                // document.execCommand('copy');
                let testingCodeToCopy = document.querySelector('#paymentLinkDesktop')
                testingCodeToCopy.setAttribute('type', 'text')
                testingCodeToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log(msg) ;
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Le lien de paiement a été copié !');
                    // alert('Testing code was copied ' + msg);
                } catch (err) {
                    // alert('Oops, unable to copy');
                    console.log(err)
                }

                /* unselect the range */
                testingCodeToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },

            // Reload la page
            reload(){
                window.location.href = "https://pay.apaym.com/" ;
            },

            // BICICI payment, select type of card (Visa or Mastercard)
            selectCardType(event){
                this.cardType = event.target.value ;
            },

            // Fermer un modal, en paramètre on a la référence du modal que l'on souhaite fermer
            closeModal(refModal) {
                
                if ( refModal == "openPaymentModal" ) {
                    this.logoOfSelectedService = "visa-qr-1.png" ;
                }

                this.$refs[refModal].hide() ;
            },

            onCancel() {
                console.log('Loader dismiss') ;
            },

            onCancelAPaym() {
                console.log('Loader APaym dismiss') ;
            },

            onCancelAPaymAuth() {
                console.log('Loader APaym Auth dismiss') ;
            },

            onCancelQr() {
                console.log('Loader QR Code dismiss') ;
            },

            onCancelMomo() {
                console.log('Loader MoMo dismiss') ;
            },

            onCancelOrange() {
                console.log('Loader Orange money dismiss') ;
            },

            onCancelWave() {
                console.log('Loader Wave dismiss') ;
            },

            onCancelFlooz() {
                console.log('Loader Flooz dismiss') ;
            },

            onCancelBicici() {
                console.log('Loader BICICI dismiss') ;
            },

            // Get information of payment page
            checkReference(ref) {

                // Set toutes la values à false
                this.qrCodeUri = "" ;
                this.orangeOkay = false ;
                this.orangeNOkay = false ;
                this.mtnOkay = false ;
                this.mtnNOkay = false ;
                this.moovNOkay = false ;
                this.moovOkay = false;

                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("reference", ref +"#");

                axios.post(apiUrl + 'api/paiement-marchand/reference-paiement',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if (response.data.code !== 1) {
                        this.showErrorPage = true ;
                        return false;
                    }

                    if (response.data.reference !== this.url_data.reference +"#") {
                        this.showErrorPage = true ;
                        return false;
                    }

                    // _reference.set(response.data["reference"]);
                    this.dataPage.slug = response.data["slug"] ;
                    window.localStorage.setItem("_reference_"+ this.dataPage.slug, response.data["reference"]) ;

                    this.refPayment = response.data["reference"] ;
                    this.showPaymentSection = true ;

                    // Generate QR Code with reference
                    // this.generateQr(response.data["reference"]) ;

                    // Set the phone number to APaym login
                    if ( response.data.numero_consumer !== "Numero inconnu" ) {

                        this.dataFormulaire.telephone = response.data.numero_consumer.replace(response.data.indice, "") ;
                        this.dataApaymPay.numApaym = response.data.numero_consumer.replace(response.data.indice, "") ;
                        this.dataApaymPayAuth.numApaym = response.data.numero_consumer.replace(response.data.indice, "") ;

                        if ( response.data.indice !== "Indice inconnu" ) {
                            this.indice = response.data.indice ;
                            this.dataApaymPayAuth.indice = response.data.indice ;
                            this.dataApaymPay.indice = response.data.indice ;
                            this.getIndiceJson() ;
                        } else {
                            this.indice = "" ;
                        }
                        
                        if ( 
                            response.data.indice == "225" && 
                            response.data.numero_consumer.replace(/\s/g, "").substring(3).length == 10 
                        ) {
                            
                            // Set MTN MoMo number if it begins by 05 or Set Moov Money number if it begins by 01
                            var indice = response.data.numero_consumer.replace(/\s/g, "").substring(3) ;
                            var first2Chiffres = indice.replace(/\s/g, "").substring(0,2) ;

                            if ( first2Chiffres == "05" ) {
                                this.dataMoMo.numero = response.data.numero_consumer.replace(/\s/g, "").substring(3) ;
                            } else if ( first2Chiffres == "01" ) {
                                this.dataMoov.numero = response.data.numero_consumer.replace(/\s/g, "").substring(3) ;
                            }
                        }

                    } else {

                        this.indice = "" ;
                        this.dataFormulaire.telephone = response.data.numero_consumer ;
                    }

                    this.dataPage.taux_apaym = response.data.taux_apaym;
                    this.dataPage.taux_cb = response.data.taux_cb;
                    this.dataPage.taux_moov = response.data.taux_moov;
                    this.dataPage.taux_mtn = response.data.taux_mtn;
                    this.dataPage.taux_om = response.data.taux_om;
                    this.dataPage.taux_wave = response.data.taux_wave;
                    this.dataPage.business_name = response.data.business ;
                    this.dataFormulaire.montant = response.data.amount ;
                    this.montantSave = response.data.amount ;
                    this.dataFormulaire.devise = response.data.currency ;
                    this.dataFormulaire.nom = response.data.consumer_name ;
                    this.dataFormulaire.society = response.data.society_name ;
                    // this.dataFormulaire.prenom = response.data.consumer_name.split(" ")[1] ;
                    this.dataPage.type = response.data.type ;
                    this.dataFormulaire.motif = trim(response.data.motif) ;
                    // this.dataPage.description_page = response.data.description_page ;
                    this.dataPage.description_page_2 = response.data.description_page;
                    this.dataPage.description_page = response.data.description_page ? this.getDescriptionTronque(response.data.description_page, 90) : response.data.description_page ;
                    this.dataPage.business_logo = response.data.business_logo !== "" ? "https://apaym.com/cms/images/logo_marchand/"+ response.data.business_logo : "" ;
                    this.dataPage.verified = response.data.verified;   
                    this.dataPage.rcc = response.data.rcc;
                    this.dataPage.business_email = response.data.MerchantEmail; 
                    this.dataPage.business_phone = response.data.MerchantPhone; 
                    this.dataPage.facebook = response.data.facebook; 
                    this.dataPage.instagram = response.data.instagram; 
                    this.dataPage.whatsapp = response.data.whatsapp; 
                    this.dataPage.nom = response.data.nom;
                    this.dataPage.ville = response.data.ville; 
                    this.dataPage.deleg_pdci = response.data.deleg_pdci; 
                    this.dataPage.frais = response.data.fees;
                    // Get Additional Data
                    this.dataYangoRechargement.driver_profil_id = response.data["driver_profil_id"] ;
                    this.dataYangoRechargement.driver_phone_number = response.data["driver_phone_number"] ;
                    this.dataYangoRechargement.profil_id = response.data["profil_id"] ;
                    this.dataYangoRechargement.ref_transaction = response.data["reference"] ;

                    // Nombre de transactions pour connaitre le statut du client
                    // BLEU (1 - 4), BRONZE (5 - 9), SILVER (10 - 19), GOLD (20 - 29), PLATINUM (30 - Infini)
                    this.nombre_transactions = response.data["nombre_transactions"] ;
                    this.is_platinum_card = response.data["is_platinum_card"] ;

                    if ( this.nombre_transactions >= 0 ) {
                        if ( this.nombre_transactions <= 20 ) {

                            this.statusClient = "Bronze" ;
                            this.imgStatus = "bronze.png" ;

                        } else if ( this.nombre_transactions <= 40 ) {

                            this.statusClient = "Silver" ;
                            this.imgStatus = "silver.png" ;

                        } else if ( this.nombre_transactions <= 65 ) {

                            this.statusClient = "Gold" ;
                            this.imgStatus = "gold.png" ;

                        } else if ( this.nombre_transactions <= 90 ) {

                            this.statusClient = "Platinum" ;
                            this.imgStatus = "platinum.png" ;

                        } else if ( this.nombre_transactions <= 130 ) {

                            this.statusClient = "Diamond" ;
                            this.imgStatus = "diamond.png" ;
                            
                        } else  {

                            this.statusClient = "Infinite" ;
                            this.imgStatus = "infinite.png" ;
                        }

                        if ( this.is_platinum_card == "1" && this.nombre_transactions <= 90 ) {
                            this.statusClient = "Platinum" ;
                            this.imgStatus = "platinum.png" ;
                        }
                    } else {
                        this.nombre_transactions = ""; // Le client n'est pas un client APaym
                    }

                    // Carte de fidélité
                    this.loyalty_card = response.data["loyalty_card"] ;
                    this.nombre_paiements = response.data["nombre_paiements"] ;
                    this.nombre_points = parseInt(response.data["nombre_points"]) ;
                    this.cadeau_a_offrir = response.data["cadeau_a_offrir"] ;

                    this.pointLoyalty = [] ;
                    this.nombre_points -= 1 ;

                    if ( this.nombre_paiements <= this.nombre_points ) { 

                        for ( let i = 0; i < this.nombre_paiements; i++ ) {

                            this.pointLoyalty.push(
                                {
                                    id: i + 1,
                                    paid: 1
                                }
                            ) ;
                        }   

                        let reste = this.nombre_points - this.nombre_paiements ;
                        let nbr = this.nombre_paiements ;
                        // for ( let i = reste ; i > 0; i-- ) {
                        for ( let i = 1; i <= reste; i++ ) {

                            this.pointLoyalty.push(
                                {
                                    id: nbr + 1 ,
                                    paid: 0
                                }
                            ) ;
                            nbr += 1 ;
                        }  

                    }  else {

                        for ( let i = 0; i < this.nombre_points; i++ ) {

                            this.pointLoyalty.push(
                                {
                                    id: i + 1,
                                    paid: 0
                                }
                            ) ;

                        }  
                    }   
                    
                    // Traitons les modes de paiement actif pour le marchand
                    for ( let i = 0; i < response.data.modes_paiement.length; i++ ) {
                        for ( let j = 0; j < this.modesPaiementDispo.length; j++ ) {

                            if ( 
                                response.data.modes_paiement[i] == this.modesPaiementDispo[j].mode
                            ) {
                                this.modesPaiementDispo[j].actif = "oui" ;
                            }
                        }
                    }

                }).catch(error => {

                    this.isLoading = false;
                    // console.log(error);
                    this.$swal(
                        'Un erreur est survenue !',
                        error.response.data,
                        'error'
                    );

                });
            },

            getDescriptionTronque(text, nombreCharAtronquer) {
                let 
                    delim = ' [suite...]',
                    length = nombreCharAtronquer
                ;

                if( nombreCharAtronquer < text.length ) {

                    while ( (text[length] != " ") && (length > 0) ) {
                        length--;
                    }

                    if (length == 0) {
                        return text.substring(0, nombreCharAtronquer) + delim;
                    }
                    
                    return text.substring(0, length) + delim;
                } 
                
                return text;
            },

            // Visa QR
            generateQr(ref, frais, montant) {

                this.isLoadingQr = true ;
                let dataSend = new FormData();
                dataSend.append("reference", ref);
                dataSend.append("frais", frais);
                dataSend.append("montant", montant);

                axios.post(apiUrl + 'api/paiement-marchand/generer-qr-code',
                    dataSend
                ).then(response => {

                    this.isLoadingQr = false;
                    if ( response.data.code == "success" ) {
                        this.qrCodeUri = response.data.qrCodeUri ;
                        return false ;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoadingQr = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            // Visa QR, payer les frais
            feeAmountQr(){

                this.checkedFeesApaym = !this.checkedFeesApaym ;
                let montant = this.montantSave ;
                let frais = 0 ;
                if ( this.checkedFeesApaym )
                {

                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_apaym) / 100 ) ) ; 
                    frais = this.checkedFeesApaym ? parseInt( montant * ( parseInt(this.dataPage.taux_apaym) / 100 ) ) : 0 ;

                    this.generateQr(
                        window.localStorage.getItem("_reference_"+ this.dataPage.slug), 
                        frais, 
                        this.dataFormulaire.montant
                    ) ;

                    return false;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;

                this.generateQr(
                    window.localStorage.getItem("_reference_"+ this.dataPage.slug), 
                    "",
                    this.dataFormulaire.montant
                ) ;
            },

            sendAPaym() {

                if (
                    this.dataApaymPay.numApaym.replace(/\s/g, "") == "" ||
                    this.dataApaymPay.codeApaym.replace(/\s/g, "") == ""  
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro de téléphone APaym ainsi que votre code de paiement !');
                    return false;
                } 

                let montant = this.montantSave, frais = 0;
                // Si le client doit obligatoirement payer les frais
                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym ) / 100;

                }  else if ( this.dataPage.frais == "1" )
                {
                    // Payer les frais est facultatif
                    if ( this.checkedFeesApaym == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100 ;
                    }

                }

                this.isLoadingAPaym = true;
                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));
                dataSend.append("numAPaym", this.dataApaymPay.indice.code +""+ this.dataApaymPay.numApaym.replace(/\s/g, ""));
                dataSend.append("codePaiement", this.dataApaymPay.codeApaym.replace(/\s/g, ""));
                dataSend.append("montant", montant);
                dataSend.append("frais", frais);

                axios.post(apiUrl + 'api/paiement-marchand/code-paiement',
                    dataSend
                ).then(response => {

                    this.isLoadingAPaym = false;
                    if ( response.data.code == 1 ) {
                        
                        this.dataPage.isDeleg == "3" ? this.doYangoRechargement() : console.log("Call back") ;
                        this.hideRecu = false ;
                        this.formPayment = true ;
                        this.showPaymentSection = false;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoadingAPaym = false;
                    // console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
                
            },

            sendAPaymAuth() {

                if (
                    this.dataApaymPayAuth.numApaym.replace(/\s/g, "") == ""   
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner numéro de téléphone APaym ainsi que votre code de paiement !');
                    return false;
                } 

                // if (this.token == null) {
                //     this.error = this.$t('payment_modal.apaym.captcha.value') ; // "Veuillez valider le captcha !";
                //     return false;
                // }

                this.isLoadingAPaymAuth = true;
                this.hideCodePay = false ;

                let dataSend = new FormData();
                dataSend.append("numero", this.dataApaymPayAuth.indice.code +""+ this.dataApaymPayAuth.numApaym.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/paiement-marchand/authentification-apaym',
                    dataSend
                ).then(response => {

                    this.isLoadingAPaymAuth = false;

                    if ( response.data.code == 1 ) {
                        
                        this.hideCodePay = true ;
                        this.dataApaymPayAuth.token = response.data.token ;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoadingAPaymAuth = false;
                    // console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
                
            },

            sendAPaymToken(){

                if (
                    this.dataApaymPayAuth.numApaym.replace(/\s/g, "") == "" ||
                    this.dataApaymPayAuth.codeApaym.replace(/\s/g, "") == ""  
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner numéro de téléphone APaym ainsi que votre code de connexion !');
                    return false;
                } 

                this.isLoadingAPaymAuth = true;
                let dataSend = new FormData();
                dataSend.append("numero", this.dataApaymPayAuth.indice.code +""+ this.dataApaymPayAuth.numApaym.replace(/\s/g, ""));
                dataSend.append("codeConnexion", this.dataApaymPayAuth.codeApaym.replace(/\s/g, ""));
                dataSend.append("token", this.dataApaymPayAuth.token);

                axios.post(apiUrl + 'api/paiement-marchand/verifier-otp',
                    dataSend
                ).then(response => {

                    this.isLoadingAPaymAuth = false;

                    if ( response.data.code == 1 ) {

                        // Mask APaym auth form
                        this.loginApaym = false ;
                        this.hideCodePay = false ;
                        
                        // Show list of cards
                        this.cards = [];
                        this.cardsLength = response.data["nombre_cards"];
                        this.showCard = true ;

                        for (let card of response.data["cards"]) {
                            
                            if (card.card_key_name == "NSIACIVISAPCN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-01.png'
                                    }
                                )
                                    
                            } else if (card.card_key_name == "UBACIVISAPPB") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-06.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAPPN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-05.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAVCN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-Virtuelle-APAYM-UBA.png'
                                    }
                                )

                            } else {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'visa-autre.png'
                                    }
                                )

                            }

                        }

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    
                    this.showCard = false ;
                    this.hideCodePay = false ;
                    this.loginApaym = true ;
                    this.dataApaymPayAuth.codeApaym = "" ;
                    this.dataApaymPayAuth.token = "" ;

                }).catch(error => {

                    this.isLoadingAPaymAuth = false;
                    this.showCard = false ;
                    this.hideCodePay = false ;
                    this.loginApaym = true ;
                    this.dataApaymPayAuth.codeApaym = "" ;
                    this.dataApaymPayAuth.token = "" ;

                    // console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });

            },

            payWithApaym(carte) {

                let montant = this.montantSave, frais = 0;
                // Si le client doit obligatoirement payer les frais
                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100;

                }  else if ( this.dataPage.frais == "1" )
                {
                    // Payer les frais est facultatif
                    if ( this.checkedFeesApaym == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_apaym) / 100 ;
                    }

                }

                this.$swal({

                    title: this.$t('payment_modal.apaym.text_validate_payment_title.value'),
                    html: this.$t('payment_modal.apaym.text_validate_payment.value')+""+ carte.nickname +" Visa **** <b>"+ carte.last_4_digit +"</b>" + this.$t('payment_modal.apaym.text_validate_payment2.value') +"<b>"+ montant +" "+ this.dataFormulaire.devise +"</b> "+ this.$t('payment_modal.apaym.text_validate_payment3.value'),
                    icon: 'info',
                    showCancelButton: true,
                    cancelButtonColor: '#6e7881',
                    confirmButtonText:  this.$t('payment_modal.apaym.text_validate_payment_yes.value'),
                    cancelButtonText: this.$t('payment_modal.apaym.text_validate_payment_no.value'), 
                    reverseButtons: true
                    
                }).then((result) => {

                    if (result.isConfirmed) {
                        
                        this.isLoadingAPaymAuth = true;
                        let dataSend = new FormData();
                        dataSend.append("numero", this.dataApaymPayAuth.indice.code +""+ this.dataApaymPayAuth.numApaym.replace(/\s/g, ""));
                        dataSend.append("token", this.dataApaymPayAuth.token);
                        dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));
                        dataSend.append("card_id", carte.id);
                        dataSend.append("montant", montant);
                        dataSend.append("frais", frais);

                        axios.post(apiUrl + 'api/paiement-marchand/apaym',
                            dataSend
                        ).then(response => {

                            this.isLoadingAPaymAuth = false;
                            this.$swal.close() ;

                            if ( response.data.code == 1 ) {

                                this.hideRecu = false ;
                                this.dataApaymPayAuth.codeApaym = "" ;
                                this.dataApaymPayAuth.token = "" ;
                                this.dataPage.isDeleg == "3" ? this.doYangoRechargement() : console.log("Call back") ;
                                this.formPayment = true ;
                                this.showPaymentSection = false;
                                return false;
                            }

                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                            this.showCard = false ;
                            this.hideCodePay = false ;
                            this.loginApaym = true ;
                            this.dataApaymPayAuth.codeApaym = "" ;
                            this.dataApaymPayAuth.token = "" ;

                        }).catch(error => {

                            this.isLoadingAPaymAuth = false;
                            console.log(error);
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                            this.showCard = false ;
                            this.hideCodePay = false ;
                            this.loginApaym = true ;
                            this.dataApaymPayAuth.codeApaym = "" ;
                            this.dataApaymPayAuth.token = "" ;

                        });
                    }
                });
            },

            disconnectApaym() {

                this.showCard = false ;
                this.hideCodePay = false ;
                this.loginApaym = true ;

                this.dataApaymPayAuth.codeApaym = "" ;
                this.dataApaymPayAuth.token = "" ;
            },

            sendVisa() {

                if (
                    this.dataVisa.pan.replace(/\s/g, "") == "" ||
                    this.dataVisa.expiration.replace(/\s/g, "") == "" ||
                    this.dataVisa.cvv.replace(/\s/g, "") == "" 
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner les informations de votre carte Visa !');
                    return false;
                }
            },

            sendBicici() { 

                if ( this.cardType == "" ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Attention', "Veuillez préciser si votre carte est Visa ou Mastercard !");
                    return false ;
                }

                this.biciciNOkay = false ;
                this.isLoadingBicici = true ;

                let dataSend = new FormData(); 
                // dataSend.append("reference", _reference.get());
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));
                dataSend.append("cardType", this.cardType);

                axios.post(apiUrl + 'api/payment-merchant/bicici',
                    dataSend
                ).then(response => {

                    this.isLoadingBicici = false ;

                    if ( response.data.code == 1 ) {

                        if ( response.data.status == "INITIALIZED" ) {

                            this.contentBicici = response.data.redirect_url ;
                            // this.$refs['openBiciciModal'].show();
                            this.isBicici = !this.isBicici ;
                            this.formBicici = !this.formBicici ;
                            this.modalBicici = true ;

                            return false;
                        }

                        sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                    return false;
                    
                }).catch(error => {

                    this.isLoadingBicici = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
                
            },

            sendCardPayment()
            {
                let montant = this.montantSave, frais = 0;

                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_cb) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_cb) / 100;

                }  else if ( this.dataPage.frais == "1" )
                {
                    if ( this.checkedFeesCb == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_cb) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_cb) / 100 ;
                    }

                }

                console.log("Calcul = "+ Math.round(montant) )

                console.log("Montant = "+ montant) ;
                console.log("Frais = "+ Math.round(frais)) ;
                console.log("Affichage des frais = "+ this.dataPage.frais)
                console.log("Ref = "+ this.url_data.reference)

                // return false;

                // window.location.href = "https://carte.abidjan.net/pro/api/init-card-payment/"+ window.localStorage.getItem("_reference_"+ this.dataPage.slug) ;
                window.location.href = apiUrl +"api/paiement-marchand/paiement-carte-bancaire/"+ this.url_data.reference.substring(0, this.url_data.reference.length - 1) +"/"+ Math.round(montant) +"/"+ Math.round(frais) ;
            },

            // Orange money payment
            sendOM(option) { 

                this.orangeOkay = false ;
                this.orangeNOkay = false ;
                this.isLoadingOrange = true ;

                let montant = this.montantSave, frais = 0;
                // Si le client doit obligatoirement payer les frais
                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_om) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_om) / 100 ;

                }  else if ( this.dataPage.frais == "1" )
                {
                    // Payer les frais est facultatif
                    if ( this.checkedFeesOm == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_om) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_om) / 100 ;
                    }

                }

                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug)) ;
                dataSend.append("montant", montant);
                dataSend.append("frais", frais);

                axios.post(apiUrl + 'api/paiement-marchand/omoney',
                    dataSend
                ).then(response => {

                    if ( response.data.code == 1 ) {

                        if ( response.data.url == null || response.data.url == "" ) {

                            this.isLoadingOrange = false ;
                            this.$refs['openOrangeMoneyModal'].hide();
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Veuillez reprendre tout le processus, si le problème persiste, veuillez essayer un autre moyen de paiement svp.");

                            return false ;
                        }

                        if ( option == "app" ) {
                            window.location.href = response.data.url ;
                            return false;
                        }

                        if ( this.isMobile() ) {
                            window.location.href = "tel:%23 144*82 %23";
                        }

                        // Open iframe in Modal
                        
                        this.isLoadingOrange = false ;
                        this.urlOrange = response.data.url ;
                        this.orangeOkay = true ;
                        this.modalOrange = true ;
                        this.$refs['openOrangeMoneyModal'].show();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.isLoadingOrange = false ;

                }).catch(error => {

                    this.isLoadingOrange = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            // Wave payment
            sendWave(){

                this.waveOkay = false ;
                this.waveNOkay = false ;
                this.isLoadingWave = true ;

                let montant = this.montantSave, frais = 0;
                // Si le client doit obligatoirement payer les frais
                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_wave) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_wave) / 100 ;

                }  else if ( this.dataPage.frais == "1" )
                {
                    // Payer les frais est facultatif
                    if ( this.checkedFeesWave == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_wave) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_wave) / 100 ;
                    }

                }

                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug)) ;
                dataSend.append("montant", montant) ;
                dataSend.append("frais", frais) ;

                axios.post(apiUrl + 'api/paiement-marchand/wave',
                    dataSend
                ).then(response => {

                    if ( response.data.code == 1 ) {

                        if ( response.data.url == null || response.data.url == "" ) {

                            this.isLoadingWave = false ;
                            this.$refs['openWaveModal'].hide();
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Veuillez reprendre tout le processus, si le problème persiste, veuillez essayer un autre moyen de paiement svp.");

                            return false ;
                        }

                        // Il s'agit d'un téléphone mobile, on lance l'app Wave directement
                        // L'utilisateur doit s'assurer d'avoir installé la version à jour de l'app
                        if ( this.isMobile() )
                        {
                            window.location.href = response.data.url ;
                            return false;
                        }

                        // Open iframe in Modal
                        this.urlWave = response.data.url ;
                        this.modalWave = true ;
                        this.$refs['openWaveModal'].show();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.isLoadingWave = false ;

                }).catch(error => {

                    this.isLoadingWave = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            sendMoMo() { 

                if (
                    this.dataMoMo.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro MoMo !');
                    return false;
                }

                this.mtnOkay = false ;
                this.mtnNOkay = false ;
                this.isLoadingMomo = true ;

                let montant = this.montantSave, frais = 0;
                // Si le client doit obligatoirement payer les frais
                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_mtn) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_mtn) / 100 ;

                }  else if ( this.dataPage.frais == "1" )
                {
                    // Payer les frais est facultatif
                    if ( this.checkedFeesMtn == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_mtn) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_mtn) / 100 ;
                    }
                }

                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));
                dataSend.append("numero", this.dataMoMo.numero.replace(/\s/g, ""));
                dataSend.append("montant", montant);
                dataSend.append("frais", frais);

                axios.post(apiUrl + 'api/paiement-marchand/momo',
                    dataSend
                ).then(response => {

                    if ( response.data.code == 1000 ) {
                        
                        this.isLoadingMomo = false ;
                        this.mtnOkay = true ;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.isLoadingMomo = false ;

                }).catch(error => {

                    this.isLoadingMomo = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            sendMoov() { 

                if (
                    this.dataMoov.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro Flooz !');
                    return false;
                }

                this.moovOkay = false ;
                this.moovNOkay = false ;
                this.isLoadingFlooz = true;

                let montant = this.montantSave, frais = 0;
                // Si le client doit obligatoirement payer les frais
                if ( this.dataPage.frais == "2" ) 
                {
                    montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_moov) / 100 ) ;
                    frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_moov) / 100 ;

                }  else if ( this.dataPage.frais == "1" )
                {
                    // Payer les frais est facultatif
                    if ( this.checkedFeesMoov == true ) {

                        montant = parseInt(this.montantSave) + ( parseInt(this.montantSave) * parseInt(this.dataPage.taux_moov) / 100 ) ;
                        frais = parseInt(this.montantSave) * parseInt(this.dataPage.taux_moov) / 100 ;
                    }
                }

                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));
                dataSend.append("numero", this.dataMoov.numero.replace(/\s/g, ""));
                dataSend.append("montant", montant);
                dataSend.append("frais", frais);

                axios.post(apiUrl + 'api/paiement-marchand/flooz',
                    // 'https://carte.abidjan.net/apaym_pro/api/payment-merchant/flooz',
                    dataSend
                ).then(response => {

                    if ( response.data.code == 1 ) {
                        
                        this.isLoadingFlooz = false ;
                        this.moovOkay = true ;
                        this.startTimer();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]); // 
                    this.isLoadingFlooz = false ;

                }).catch(error => {

                    this.isLoadingFlooz = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            checkingFloozStatus() {

                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));

                axios.post(apiUrl + 'api/paiement-marchand/statut-flooz',
                    // 'https://carte.abidjan.net/apaym_pro/api/payment-merchant/verify-flooz-status',
                    dataSend
                ).then(response => {

                    // console.log(response) ;

                    // Transaction was successfully
                    if ( response.data.statusCode == 0 ) {

                        clearInterval(this.stopInterval);
                        this.dataPage.isDeleg == "3" ? this.doYangoRechargement() : console.log("Call back") ;
                        this.isLoadingFlooz = false ;
                        this.hide = false ;
                        this.modePay = "Moov Money" ;
                        this.formPayment = true ;
                        this.showPaymentSection = false ;

                    } else if ( response.data.statusCode == 47 ) {
                        
                        // Transaction is still pending
                        this.showVerifMoov = false ;
                        this.showInProcessMoov = true ;
                        this.checkMoovAgain();
                        return false ;

                    } else  {

                        // Transaction was failed
                        clearInterval(this.stopInterval);
                        this.isLoadingFlooz = false ;
                        this.moovNOkay = true ;
                        this.moovOkay = false;
                    }

                }).catch(error => {

                    clearInterval(this.stopInterval);
                    this.isLoadingFlooz = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            checkMoovAgain(){
                // Vérification du statut de la transaction Flooz
                this.stopInterval = setInterval(() => {
                    this.checkingFloozStatus() ;
                }, 60000); // 60s => 1min
            },

            unSlugify(slug) {
                const result = slug.replace(/\-/g, " ");
                return result.replace(/\w\S*/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            },

            isMobile() {
                var check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            },

            async print () {
                // Pass the element id here
                await this.$htmlToPaper('printMe');
            },

            getIndiceJson(){

                this.json = [...json];
                this.options = [] ;

                for ( let j of this.json ) {
                    this.options.push(
                        {
                            country_code: j.flag +" +"+ j.dial_code ,
                            country: j.flag +" "+ j.name +" +"+ j.dial_code ,
                            code: j.dial_code
                        }
                    )
                }

                // Indicatifs
                this.indice = this.options.find(option => option.code === this.indice);
                this.dataApaymPay.indice = this.options.find(option => option.code === this.dataApaymPay.indice);
                this.dataApaymPayAuth.indice = this.options.find(option => option.code === this.dataApaymPayAuth.indice);

                // Indicatif pour les mobile money ivoiriens
                this.indiceMobileMoney = this.options.find(option => option.code === "225");
            },

            onChange(event) {
                window.localStorage.setItem("lang", event.target.value)
            },

            selectMenu(payment){
                
                this.menuSelected = payment ;
                this.showMenu = !this.showMenu ;
                this.showHeader = !this.showHeader ;
                this.showContent = !this.showContent ;

                this.dataFormulaire.montant = this.montantSave ;

                this.checkedFeesApaym = false ;
                this.checkedFeesOm = false ;
                this.checkedFeesCb = false ;
                this.checkedFeesWave = false ;
                this.checkedFeesMtn = false ;
                this.checkedFeesMoov = false ;

                switch(payment) {

                    case "Visa QR":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {

                            this.checkedFeesApaym = !this.checkedFeesApaym ;
                            // Générons le QR Code prenant en compte le frais obligatoire
                            this.feeAmountQr() ;

                        } else {

                            // Générons le QR Code
                            this.generateQr(
                                window.localStorage.getItem("_reference_"+ this.dataPage.slug), 
                                "", 
                                this.dataFormulaire.montant
                            ) ;
                        }

                        this.logoSmallDevice = "visa-qr.png" ;

                    break;

                    case "VISA":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesCb = !this.checkedFeesCb ;
                            this.tauxMontant( this.dataPage.taux_cb ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "visa.png" ;

                    break;

                    case "MASTERCARD":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesCb = !this.checkedFeesCb ;
                            this.tauxMontant( this.dataPage.taux_cb ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "mastercard.png" ;

                    break;

                    case "Orange Money":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesOm = !this.checkedFeesOm ;
                            this.tauxMontant( this.dataPage.taux_om ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "om.png" ;

                    break;

                    case "Wave":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesWave = !this.checkedFeesWave ;
                            this.tauxMontant( this.dataPage.taux_wave ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "wave.png" ;

                    break;

                    case "MTN Money":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesMtn = !this.checkedFeesMtn ;
                            this.tauxMontant( this.dataPage.taux_mtn ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "momo.png" ;

                    break;

                    case "Moov Money":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesMoov = !this.checkedFeesMoov ;
                            this.tauxMontant( this.dataPage.taux_moov ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "flooz.png" ;

                    break;

                    case "APaym USSD":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesApaym = !this.checkedFeesApaym ;
                            this.tauxMontant( this.dataPage.taux_apaym ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "apaym-ussd.png" ;

                    break;

                    case "APaym":

                        // On paie les frais obligatoirement
                        if ( this.dataPage.frais == "2" ) {
                            this.checkedFeesApaym = !this.checkedFeesApaym ;
                            this.tauxMontant( this.dataPage.taux_apaym ) ;

                        } else {

                            console.log("Paiement par "+ payment ) ;
                        }

                        this.logoSmallDevice = "apaym.png" ;

                    break;
                }

                this.cardType = payment == 'VISA' || payment == 'MASTERCARD' ? payment : '' ;
                this.typeCarte = this.cardType.charAt(0).toUpperCase() + this.cardType.slice(1).toLowerCase() ;
            },

            getIpAddress(){
                axios.get('http://ipinfo.io/json?token=8c8fd7115a940f').then(response => {
                    console.log(response)
                    // this.dataYangoRechargement.adresse_ip = response.data.ip ;
                    this.dataYangoRechargement.adresse_ip = response.data.ip +" - "+ response.data.org +" | "+ response.data.country +" - "+ response.data.city +" - "+ response.data.region ;
                    console.log(this.dataYangoRechargement.adresse_ip);
                }).catch(err => {
                    console.log(err) ;
                });
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais obligatoire à payer
            tauxMontant(taux)
            {
                let montant = this.montantSave, frais = 0 ;
                this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(taux) / 100 ) ); 

                frais = parseInt( montant * ( parseInt(taux) / 100 ) ) ;
                // On lance la requête pour modifier le montant ainsi que le frais
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais à payer
            tauxMontantOm()
            {
                let montant = this.montantSave, frais = 0 ;
                this.checkedFeesOm = !this.checkedFeesOm ;

                if ( this.checkedFeesOm )
                {
                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_om) / 100 ) ); 
                    frais = parseInt( montant * ( parseInt(this.dataPage.taux_om) / 100 ) ) ;
                    // On lance la requête pour modifier le montant ainsi que le frais
                    // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
                    
                    return false ;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais à payer
            tauxMontantWave()
            {
                let montant = this.montantSave, frais = 0 ;
                this.checkedFeesWave = !this.checkedFeesWave ;
  
                if ( this.checkedFeesWave )
                {
                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_wave) / 100 ) ); 
                    frais = parseInt( montant * ( parseInt(this.dataPage.taux_wave) / 100 ) ) ;
                    // On lance la requête pour modifier le montant ainsi que le frais
                    // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
                    
                    return false ;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais à payer
            tauxMontantMtn()
            {
                let montant = this.montantSave, frais = 0 ;
                this.checkedFeesMtn = !this.checkedFeesMtn ;
                    
                if ( this.checkedFeesMtn )
                {
                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_mtn) / 100 ) ); 
                    frais = parseInt( montant * ( parseInt(this.dataPage.taux_mtn) / 100 ) ) ;
                    // On lance la requête pour modifier le montant ainsi que le frais
                    // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
                    
                    return false ;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais à payer
            tauxMontantMoov()
            {
                let montant = this.montantSave, frais = 0 ;
                this.checkedFeesMoov = !this.checkedFeesMoov ;
   
                if ( this.checkedFeesMoov )
                {
                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_moov) / 100 ) ); 
                    frais = parseInt( montant * ( parseInt(this.dataPage.taux_moov) / 100 ) ) ;
                    // On lance la requête pour modifier le montant ainsi que le frais
                    // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
                    
                    return false ;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais à payer
            tauxMontantCb()
            {
                let montant = this.montantSave, frais = 0 ;
                this.checkedFeesCb = !this.checkedFeesCb ;

                if ( this.checkedFeesCb )
                {
                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_cb) / 100 ) ) ; 
                    frais = parseInt( montant * ( parseInt(this.dataPage.taux_cb) / 100 ) ) ;
                    // On lance la requête pour modifier le montant ainsi que le frais
                    // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
                    
                    return false ;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Calculer le montant total à payer prenant en 
            // compte le frais à payer
            tauxMontantApaym()
            {
                let montant = this.montantSave, frais = 0 ;
                this.checkedFeesApaym = !this.checkedFeesApaym ;

                if ( this.checkedFeesApaym )
                {
                    this.dataFormulaire.montant = parseInt(montant) + parseInt( montant * ( parseInt(this.dataPage.taux_apaym) / 100 ) ) ; 
                    frais = parseInt( montant * ( parseInt(this.dataPage.taux_apaym) / 100 ) ) ;
                    // On lance la requête pour modifier le montant ainsi que le frais
                    // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
                    
                    return false ;
                }

                this.dataFormulaire.montant = this.montantSave ;
                frais = 0 ;
                // this.modifierMontantFrais(this.dataFormulaire.montant, frais) ;
            },

            // Modifier le montant et le frais de la transaction
            // Cas de paiement des frais (Obligatoire ou pas)
            modifierMontantFrais(montant, frais)
            {
                // console.log("Montant = " + montant) ;
                // console.log("Frais = " + frais) ;
                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("reference", window.localStorage.getItem("_reference_"+ this.dataPage.slug));
                dataSend.append("frais", frais);
                dataSend.append("montant", montant);

                axios.post(apiUrl + 'api/paiement-marchand/frais-montant',
                    dataSend
                ).then(response => {

                    this.isLoading = false;
                    if ( response.data.code == 1 ) {
                        return false ;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            doYangoRechargement() {
                this.isLoading = true;
                let dataToSend = new FormData();
                dataToSend.append("driver_profile_id", this.dataYangoRechargement.driver_profil_id);
                dataToSend.append("amount", this.montantSave);
                dataToSend.append("profil_id", this.dataYangoRechargement.profil_id);
                dataToSend.append("ref_transaction", this.dataYangoRechargement.ref_transaction);
                dataToSend.append("driver_phone_number", this.dataYangoRechargement.driver_phone_number);
                dataToSend.append("adresse_ip", this.dataYangoRechargement.adresse_ip);
                dataToSend.append("device_ID", this.$browserDetect.meta.ua);
                dataToSend.append("phone_Name", this.$browserDetect.meta.name+" "+this.$browserDetect.meta.version);

                axios.post(apiUrl +'api/paiement-marchand/rechargement-yango', // 'https://carte.abidjan.net/apaym_pro/api/rechargementYango',
                    dataToSend
                ).then(response => {
                    console.log(response);
                    this.isLoading = false;
                }).catch(err =>{
                    console.log(err);
                    this.isLoading = false;
                });
            },

            onTimesUp() {
                clearInterval(this.timerInterval);
            },

            startTimer() {
                this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
            },

            onVerify(token, ekey) {
                this.verified = true;
                this.token = token;
                this.eKey = ekey;
                console.log(`Callback token: ${token}, ekey: ${ekey}`);
            },

            onExpired() {
                this.verified = false;
                this.token = null;
                this.eKey = null;
                this.expired = true;
                console.log('Expired');
            },

            onError(err) {
                this.token = null;
                this.eKey = null;
                this.error = err;
                this.verified = false;
                console.log(`Error: ${err}`);
            },

            letSomeonePay()
            {
                this.showPaymentSection = !this.showPaymentSection ;
                this.sharingSection = !this.sharingSection ;
            }
            
        },
        mounted() {

            this.mobileDevice = this.isMobile() ;
            this.getIndiceJson() ;
            // this.isMobile() ;
            
            this.url_data.reference = this.$route.params.reference;
            if (!this.url_data.reference) {
                this.showErrorPage = true ;
                return false;
            }

            this.checkReference(this.url_data.reference);

            // Update screen page with pusher 
            Pusher.logToConsole = false;
            var channel = this.$pusher.subscribe('wby-channel');
            var my = this ;
            var response = function(data) {

                if ( localStorage.getItem("route") == "defaultPage" || localStorage.getItem("route") == "refPage" ) {

                    if ( my.dataFormulaire.montant.toString() !== "" ) {

                        if ( data.type == "QR" ) {
                            my.modePayment = "Visa QR" ;
                        } else if ( data.type == "BICICI" ) {    
                            my.modePayment = my.$t('payment_modal.bicici.value') ;
                        } else {
                            my.modePayment = data.type ;
                        }

                        if ( data.type == "QR" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.modePay = "Visa QR" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;
                                return false;
                            }      

                        } else if ( data.type == "MTN Money" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.modePay = "MTN Money" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;

                            } else if ( (data.responseCode == "529" || data.responseCode == "515" || data.responseCode == "9" || data.responseCode == "100")  && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.isLoadingMomo = false ;
                                my.mtnNOkay = true ;
                                my.mtnOkay = false;
                            }

                        } else if ( data.type == "Orange Money" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {
                                
                                my.modePay = "Orange Money" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;
                                my.modalOrange == true ? my.$refs['openOrangeMoneyModal'].hide() : "";

                            } else if ( data.responseCode !== "SUCCESS" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.isLoadingOrange = false ;
                                my.orangeNOkay = true ;
                                my.orangeOkay = false;
                                my.modalOrange == true ? my.$refs['openOrangeMoneyModal'].hide() : "";
                            }

                        } else if ( data.type == "WAVE" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {
                                
                                my.modePay = "Wave" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.$refs['openWaveModal'].hide();
                                my.showPaymentSection = false;
                                my.formPayment = true ;

                            } else if ( data.responseCode !== "SUCCESS" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.isLoadingWave = false ;
                                my.waveNOkay = true ;
                                my.waveOkay = false ;
                                my.$refs['openWaveModal'].hide();
                            }

                        }  else if ( data.type == "BICICI" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.modePay = "Cartes Bancaires" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;
                                // my.modalBicici == true ? my.$refs['openBiciciModal'].hide() : "";

                            } else if ( data.responseCode !== "BICICI-SUCCESS" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.formBicici = false ;
                                my.isBicici = false ;
                                my.cardType = "" ;
                                my.biciciNOkay = true;
                                // my.modalBicici == true ? my.$refs['openBiciciModal'].hide() : "";
                            }
                        }
                    }

                } else {
                    console.log("Payment Page") ;
                }
                
            };

            // Écouteur sur les mises à jour des paiements pour checker le statut
            channel.bind('payment-merchant', response);

        },
        watch: {
            timeLeft(newValue) {
                if (newValue === 0) {
                    this.onTimesUp();
                    this.showVerifMoov = true ;
                    this.checkingFloozStatus() ;
                }
            },
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .btn-close-modal {
        position: absolute;
        font-size: 15px;
        color: #1b1e21;
        top: -4px;
        cursor: pointer;
        font-weight: 700;
        left: 102%;
        height: 25px;
        width: 25px;
    }

    .btn-close-modal-small {
        position: absolute;
        color: #1b1e21;
        top: 0px;
        cursor: pointer;
        font-weight: 700;
        right: 0;
        height: 25px;
        width: 25px;
    }

    .text-modal-small {
        position: relative;
        color: #1b1e21;
        top: 5px;
        font-size: 16px;
        display: flex;
        justify-content: center;
        white-space: break-spaces;
        align-items: baseline;
    }

    .btn-disabled-custom {
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        color: #1b1e21;
    }

    .searchIcon {
        margin-left: -35px;
        cursor: pointer;
        color: #343a40;
        cursor: pointer;
        font-size: 25px;
        z-index: 50;
    }

    .payment__type {
        cursor: pointer;
        transition: all 0.15s ease;
        margin-right: 0px;
        white-space: nowrap;
    }

    .pdf-content {
        width: 100%;
        background: #fff;
    }

    .pdf-content .report-info {
        display: flex;
        padding: 20px;
        padding-bottom: 0px;
    }

    .pdf-content .report-info .user-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }

    .blocAbsolute {
        display: flex;
        position: absolute;
        flex-direction: row;
        z-index: 1;
        align-items: center;
        width: 100%;
        padding: 3px;
        justify-content: space-between;
        border-bottom: 1px solid rgb(255, 159, 0);
    }

    .blocNonAbsolute {
        display: flex;
        flex-direction: row;
        z-index: 1;
        align-items: center;
        width: 100%;
        padding: 3px;
        justify-content: space-between;
        border-bottom: 1px solid rgb(255, 159, 0);
    }

    .timer {
        position: relative;
        /* top: 6px; */
        font-size: 28px;
        font-weight: 700;
        color: #db110d;
    }

</style>
